module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "ch",
    attrs: {
      "id": "BODY4.1.1"
    }
  }, [_vm._v("1. Justification and the Righteousness of God (3:21–26)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("21")]), _vm._v("But now, apart from the law, the righteousness of God has been made manifest, being witnessed to by the law and the prophets, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("22")]), _vm._v("the righteousness of God that is through faith in Jesus Christ for all"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.218.2",
      "id": "FN.218.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿2")]), _vm._v(" who believe. For there is no distinction, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("23")]), _vm._v("for all have sinned and are falling short of the glory of God, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("24")]), _vm._v("being justified freely by his grace through the redemption that is in Christ Jesus. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("25")]), _vm._v("God set forth Jesus as a propitiatory sacrifice through faith,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.218.3",
      "id": "FN.218.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" in his blood, for a demonstration "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.219"
    }
  }), _vm._v("of his righteousness because of the passing over of sins committed beforehand "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("26")]), _vm._v("in the forbearance of God, for a demonstration of his righteousness at the present time, in order that he might be just and the justifier of the person who has faith in Jesus.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("In a passage that is loaded with key theological terms, the phrase “righteousness of God” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(dikaiosynē theou)")]), _vm._v(" stands out. It occurs four times (vv. 21, 22, 25, 26 [“his righteousness” in the last two]), while the related verb “justify” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(dikaioō)")]), _vm._v(" is found twice (vv. 24, 26) and the adjective “just” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(dikaios)")]), _vm._v(" once (v. 26). After a section in which the need for this righteousness has been demonstrated in detail (1:18–3:20), Paul is now prepared to explain how the righteousness of God—his eschatological justifying activity—empowers the gospel to mediate salvation to sinful human beings (cf. 1:16–17). The passage falls into four parts. In the first, Paul reiterates (cf. 1:17) the revelation of God’s righteousness and relates it to the OT (v. 21). The second section focuses on the way in which all human beings, equal in their sin, have equal access also to God’s righteousness through faith (vv. 22–23). The source of God’s righteousness in the gracious provision of Christ as an atoning sacrifice is the theme of the third part of the passage (vv. 24–25a). Finally, Paul shows how the atonement not only provides for the justification of sinners but also demonstrates the “just-ness” of God throughout the process (vv. 25b–26). In making this last point, we are presuming that “righteousness of God,” which refers in vv. 21–22 to the justifying act of God, refers in vv. 25–26 to the “integrity” of God, his always acting in complete accordance with his own character."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.219.4",
      "id": "FN.219.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" Most contemporary exegetes and theologians reject this interpretation; but we are convinced that this shift in meaning is required by the data of the text, and, indeed, gives to the text its extraordinary power and significance. For, as James Denney says,")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("There can be no gospel unless there is such a thing as a righteousness of God for the ungodly. But just as little can there be any gospel unless the integrity of God’s character be maintained. The problem of the sinful world, the problem of all religion, the problem of God in dealing with a sinful race, is how to unite these two things. The Christian answer to the problem is given by Paul in the words: “Jesus Christ, whom God set forth a propitiation (or, in propitiatory power) in his blood.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.219.5",
      "id": "FN.219.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.220"
    }
  }), _vm._v("The occurrence in this passage of some words and concepts that are not typical of Paul’s presentation of the gospel"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.220.6",
      "id": "FN.220.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿6")]), _vm._v(" suggests to many scholars that Paul is quoting an early Christian tradition."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.220.7",
      "id": "FN.220.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" This is possible, but it is more likely that Paul has himself written these verses in dependence on a certain Jewish-Christian interpretation of Jesus’ death. This interpretation, which appears also in Heb. 9–10, viewed Jesus’ death as the fulfillment of "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.221"
    }
  }), _vm._v("the Day of Atonement ritual."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.221.8",
      "id": "FN.221.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" Perhaps Paul used such a tradition at this point in Romans both because it suited his argument and because it created yet another point of contact with the Jewish Christians in Rome.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("21")]), _vm._v(" Paul signals the transition to a new phase of his exposition of the gospel with “but now.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.221.9",
      "id": "FN.221.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" The phrase could have a purely logical force—“but now here is the situation apart from the law”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.221.10",
      "id": "FN.221.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v("—but is more likely to preserve its normal temporal meaning. As in 6:22, 7:6, 1 Cor. 15:20, Eph. 2:13, and Col. 1:22, “but now” marks the shift in Paul’s focus from the old era of sin’s domination to the new era of salvation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.221.11",
      "id": "FN.221.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" This contrast between two eras in salvation history is one of Paul’s most basic theological conceptions, providing the framework for many of his key ideas. Rom. 1:18–3:20 has sketched the spiritual state of those who belong to the old era: justly condemned, helpless in the power of sin, powerless to escape God’s wrath. “But now” God has intervened to inaugurate a new era, and all who respond in faith—not only after the cross, but, as Rom. 4 will show, before it also—will be transferred into it from the old era. No wonder Lloyd-Jones can exclaim, “there are no more wonderful words in the whole of Scripture than just these two words ‘But now.’ ”")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.222"
    }
  }), _vm._v("As “the wrath of God” dominated the old era (1:18), so “the righteousness of God” dominates the new. “Righteousness of God” means the same here as in Rom. 1:17: the justifying activity of God. From God’s side, this includes his eschatological intervention to vindicate and deliver his people, in fulfillment of his promises. From the human side, it includes the status of acquittal acquired by the person so declared just."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.222.12",
      "id": "FN.222.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" In 1:17, Paul asserts that this “righteousness of God” is constantly revealed"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.222.13",
      "id": "FN.222.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿13")]), _vm._v(" through the preaching of the gospel. Here he simply asserts its presence as a dominating force in God’s interaction with humanity."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.222.14",
      "id": "FN.222.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', [_vm._v("The relationship of this manifestation of God’s righteousness to the OT is indicated in two prepositional phrases that together display the combination of continuity and discontinuity in salvation history that is characteristic of Romans. “Apart from the law” could go with “righteousness of God” (cf. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.KJV"
    }
  }, [_vm._v("KJV")]), _vm._v(", “the righteousness of God without the law is manifested”),"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.222.15",
      "id": "FN.222.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" but it makes better sense if taken with the verb “is manifested” (cf. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NAB"
    }
  }, [_vm._v("NAB")]), _vm._v(", “the righteousness of God has been manifested apart from the law”)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.222.16",
      "id": "FN.222.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" Paul’s purpose is to announce the way in which God’s righteousness has been manifest rather than to contrast two kinds of righteousness.")]), _vm._v(" "), _c('p', [_vm._v("What does Paul mean by this? In Rom. 2:1–3:20 Paul has made clear that the law has failed to rescue Jews from the power of sin because compliance with its demands to the extent necessary to secure justification has not been—and cannot be—forthcoming. “Apart from the law” might mean, then, “apart from doing the law”: God’s righteousness is now attained without any contribution from “works of the law.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.222.17",
      "id": "FN.222.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" While this may, indeed, be part of what Paul intends, it is questionable whether it goes far enough; for there is, as Paul will show in chap. 4, nothing really “new” about this: justification "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.223"
    }
  }), _vm._v("has always been by faith, apart from the law. Furthermore, it is not the manner in which God’s righteousness is "), _c('i', [_vm._v("received")]), _vm._v(" that Paul is talking about here, but the manner in which it is "), _c('i', [_vm._v("manifested—")]), _vm._v("the divine side of this “process” by which people are made right with God. This phrase, then, reiterates the salvation-historical shift denoted by “but now.” In the new era inaugurated by Christ’s death God has acted to deliver and vindicate his people “apart from” the law. It is not primarily the law as something for humans to do, but the law as a system, as a stage in God’s unfolding plan, that is in view here. “Law” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(nomos),")]), _vm._v(" then, refers to the “Mosaic covenant,” that (temporary) administration set up between God and his people to regulate their lives and reveal their sin until the establishment of the promise in Christ."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.223.18",
      "id": "FN.223.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" One aspect of this covenant, of course, is those Jewish “identity markers,” such as circumcision, the Sabbath, and food laws; Paul is certainly affirming, then, that the righteousness of God is now being manifested “outside the national and religious parameters set by the law.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.223.19",
      "id": "FN.223.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" But Paul’s point cannot be confined to this. The reason these “identity markers” are no longer required is that the covenant of which they were a part has been made “obsolete” (cf. Heb. 8:7–13). It is this basic shift in salvation history that Paul alludes to here, and much of his discussion of the law in the rest of this letter (cf. 3:27–31; 4:15; 5:13, 20; 6:14; and especially chap. 7) is an attempt to explain this “apart from the law,” while at the same time justifying his assertion that faith “establishes” the law (cf. 3:31; 8:4).")]), _vm._v(" "), _c('p', [_vm._v("But Paul hastens to balance this discontinuity in salvation history with a reminder of its continuity. While God’s justifying activity in the new age takes part outside the confines of the Old Covenant, the OT as a whole anticipates and predicts this new work of God: God’s righteousness is “witnessed to"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.223.20",
      "id": "FN.223.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿20")]), _vm._v(" by the law and the prophets.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.223.21",
      "id": "FN.223.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.224"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_vm._v("22a")]), _vm._v(" “Righteousness of God,” repeated for clarity because of the distance from its first occurrence, is now considered from the “human” side of the transaction: it is “through"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.224.22",
      "id": "FN.224.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿22")]), _vm._v(" faith in Jesus Christ for all who believe.” Picking up another key theme from 1:17, Paul highlights faith as the means by which God’s justifying work becomes applicable to individuals. This, at least, is how this phrase has usually been interpreted (and cf. almost all modern English translations). But an alternative interpretation has been gaining favor. On this view, Paul asserts not that God’s righteousness is attained “through faith "), _c('i', [_vm._v("in")]), _vm._v(" Jesus Christ,” but “through the faith "), _c('i', [_vm._v("of")]), _vm._v(" Jesus Christ,” or “through the faithfulness "), _c('i', [_vm._v("shown by")]), _vm._v(" Jesus Christ.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.224.23",
      "id": "FN.224.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(" Advocates of this interpretation argue that it is the more likely linguistically"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.224.24",
      "id": "FN.224.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿24")]), _vm._v(" and that it makes better sense in the context. For this interpretation avoids the tautology involved in the traditional view, which has Paul asserting the importance of human faith twice: “faith in Jesus Christ,” “for all who believe.” On the other hand, the translation “through the faithfulness of Jesus Christ” results in a natural Pauline combination of divine initiative and human response."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.224.25",
      "id": "FN.224.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.225"
    }
  }), _vm._v("Despite these arguments, the traditional interpretation of the phrase is preferable. The linguistic argument in favor of the alternative rendering is by no means compelling."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.225.26",
      "id": "FN.225.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" In addition, contextual considerations favor the objective genitive in Rom. 3:22. While the Greek word "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("pistis")]), _vm._v(" can mean “faithfulness” (see 3:3), and Paul can trace our justification to the obedience of Christ (5:19), little in this section of Romans would lead us to expect a mention of Christ’s “active obedience” as basic to our justification."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.225.27",
      "id": "FN.225.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" Moreover, "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("pistis")]), _vm._v(" in Paul almost always means “faith”; very strong contextual features must be present if any other meaning is to be adopted."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.225.28",
      "id": "FN.225.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" But these are absent in 3:22. If, on the other hand, "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("pistis")]), _vm._v(" is translated “faith,” it is necessary to introduce some very dubious theology in order to speak meaningfully about “the faith exercised by Jesus Christ.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.225.29",
      "id": "FN.225.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(" Finally, and most damaging to the hypothesis in either form, is the consistent use of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("pistis")]), _vm._v(" throughout 3:21–4:25 to designate the faith exercised by people in God, or Christ, as the sole means of justification. Only very strong reasons would justify giving to "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("pistis")]), _vm._v(" any other meaning in this, the theological summary on which the rest of the section depends. The simple references to “faith” in 3:28 and 3:30 are abbreviations of the “faith in Christ/Jesus” that is enunciated in 3:22 and 26 (cf. v. 25)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.225.30",
      "id": "FN.225.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('p', [_vm._v("But if Paul mentions human faith in this phrase, why then does he add the phrase “for all who believe”? Comparison has been made with the combination “from faith for faith” in 1:17, but this is to appeal from the uncertain "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.226"
    }
  }), _vm._v("to the obscure (see the notes on 1:17). Paul’s purpose is probably to highlight the universal availability of God’s righteousness. This theme is not only one of the most conspicuous motifs of the epistle, but is explicitly mentioned in vv. 22b–23. God’s righteousness is available only through faith in Christ—but it is available to "), _c('i', [_vm._v("anyone")]), _vm._v(" who has faith in Christ.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("22b–23")]), _vm._v(" Paul tells us in vv. 22b–23 why this righteousness is available to all, and why, also, all need this righteousness. “There is no distinction” summarizes a key element of Paul’s presentation in 1:18–3:20, and is likely, therefore, to have special application to Jew and Gentile."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.226.31",
      "id": "FN.226.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(" In v. 23, Paul elaborates this point. His “no distinction,” as we would expect, has to do with the absence of any basic difference among people with respect to their standing before God. Jews may have the law and circumcision; Americans may lay claim to a great religious heritage; “good” people may point to their works of charity; but all this makes no essential difference to one’s standing before the righteous and holy God. Paul reduces the argument of 1:18–3:20 to its essence in a justly famous statement of the condition of all people outside Christ: “all have sinned"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.226.32",
      "id": "FN.226.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿32")]), _vm._v(" and are falling short of the glory of God.” The second verb states the consequences of the first: because all have sinned, all are falling short"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.226.33",
      "id": "FN.226.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿33")]), _vm._v(" of the glory of God. “Glory” in the Bible characteristically refers to the magnificent presence of the Lord, and the eternal state was often pictured as a time when God’s people would experience and have a part in that “glory” (e.g., Isa. 35:2; Rom. 8:18; Phil. 3:21; 2 Thess. 2:14)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.226.34",
      "id": "FN.226.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" And just as this sharing in God’s “glory” involves conformity to the “image of Christ” (Rom. 8:29–30; Phil. 3:21), so the absence of glory involves a declension from the “image of God” in which human beings were first made. “The future glory may be regarded as the restoration of the lost, original glory.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.226.35",
      "id": "FN.226.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" Paul, then, is indicating that all people fail to exhibit that “being-like-God” for which they were created; and the present "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.227"
    }
  }), _vm._v("tense of the verb, in combination with Rom. 8, shows that even Christians “fall short” of that goal until they are transformed in the last day by God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.227.36",
      "id": "FN.227.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("24")]), _vm._v(" The connection between this verse and the previous verses is not clear. Those who think a pre-Pauline fragment begins here find in the difficult transition evidence for a shift from Paul’s original dictation to the citation of a tradition. But whatever his dependence on tradition, Paul is himself composing the verses, and we need to determine what connection he intends. The participle “being justified”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.227.37",
      "id": "FN.227.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" is most naturally taken as a modifier of one or both of the finite verbs in v. 23: “sinned” and/or “falling short.” If so, Paul’s purpose in highlighting the gift character of justification in the participial clause would presumably be to provide evidence for the total religious impotence of humanity."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.227.38",
      "id": "FN.227.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" The objection to this interpretation is that it gives to a verse (24) that continues the main theme of the paragraph (justification/righteousness) a relatively subordinate role. Scholars suggest several other ways of relating this participle to its context,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.227.39",
      "id": "FN.227.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" but perhaps the best suggestion is Cranfield’s. He argues that “being justified” is dependent on v. 23, to the extent that it has as its subject “all,” but that it also picks up and continues the main theme of the paragraph from vv. 21–22a. With this we would agree, with the caveat that “all” in its connection with “being justified” indicates not universality (“everybody”) but lack of particularity (“anybody”). Paul’s stress on the gift character of justification in v. 24 illuminates from the positive side the “lack of distinction” in God’s dealings (vv. 22b–23) even as it continues and explains the theme of “righteousness by faith” from v. 22a.")]), _vm._v(" "), _c('p', [_vm._v("Paul uses the verb “justify” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(dikaioō)")]), _vm._v(" for the first time in Romans to depict his distinctive understanding of Christian salvation. As Paul uses it in these contexts, the verb “justify” means not “to make righteous” (in an ethical sense) nor simply “to treat as righteous” (though one is really not righteous), but “to declare righteous.” No “legal fiction,” but a legal "), _c('i', [_vm._v("reality")]), _vm._v(" of the utmost significance, “to be justified” means to be acquitted by God from all “charges” that could be brought against a person because of his or her sins."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.227.40",
      "id": "FN.227.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.228"
    }
  }), _vm._v("This judicial verdict, for which one had to wait until the last judgment according to Jewish theology, is according to Paul rendered the moment a person believes. The act of justification is therefore properly “eschatological,” as the ultimate verdict regarding a person’s standing with God is brought back into our present reality.")]), _vm._v(" "), _c('p', [_vm._v("Characteristic also of Paul’s theology is his emphasis on the gift character of this justifying verdict; we are “justified freely"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.228.41",
      "id": "FN.228.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿41")]), _vm._v(" by his grace.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.228.42",
      "id": "FN.228.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" “Grace” is one of Paul’s most significant theological terms."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.228.43",
      "id": "FN.228.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" He uses it typically not to describe a quality of God but the way in which God has acted in Christ: unconstrained by anything beyond his own will."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.228.44",
      "id": "FN.228.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" God’s justifying verdict is totally unmerited. People have done, and can do, nothing to earn it. This belief is a “theological axiom” for Paul and is the basis for his conviction that justification can never be attained through works, or the law (cf. Rom. 4:3–5, 13–16; 11:6), but only through faith."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.228.45",
      "id": "FN.228.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" Once this is recognized, the connection between v. 22a and v. 24 is clarified; that justification is a matter of grace on God’s side means that it must be a matter of faith on the human side. But the gracious nature of justification also answers to the dilemma of people who are under the power of sin (v. 23). As Pascal says, “Grace is indeed needed to turn a man into a saint; and he who doubts it does not know what a saint or a man is.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.228.46",
      "id": "FN.228.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.229"
    }
  }), _vm._v("What gives this paragraph its unparalleled significance is the number of perspectives from which God’s justification of sinners is considered. If “freely by his grace” indicates the mode of justification, as entirely free and unmerited, “through the redemption” illumines the costly means by which this acquitting verdict is rendered possible. “Redemption”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.229.47",
      "id": "FN.229.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" means, basically, “liberation through payment of a price.” Thus, in the second and first centuries "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("B.C.")]), _vm._v(", “redemption” often refers to the “ransoming” of prisoners of war, slaves, and condemned criminals."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.229.48",
      "id": "FN.229.48r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" If “redemption” has this connotation here, then Paul would be presenting Christ’s death as a “ransom,” a “payment” that takes the place of that penalty for sins “owed” by all people to God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.229.49",
      "id": "FN.229.49r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" Though widely rejected today,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.229.50",
      "id": "FN.229.50r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" this interpretation of the significance of the word should be retained."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.229.51",
      "id": "FN.229.51r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")]), _vm._v(" While it is not clear whether Paul was thinking specifically "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.230"
    }
  }), _vm._v("of slave manumissions when he applied the word to Christian salvation,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.230.52",
      "id": "FN.230.52r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")]), _vm._v(" it is likely that Paul views sin as that power from which we need to be liberated (cf. 3:9)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.230.53",
      "id": "FN.230.53r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")]), _vm._v(" If we ask further the question “To whom was the ‘ransom’ paid?” it is not clear that we need to answer it. The usage of the word makes it clear that there need be no specific person who “receives” the “payment.” Certainly we are not to think of Christ’s death as a payment of God made to Satan, a view that became very popular in the first centuries of the Christian church. A more biblical answer, and one that might be implied by v. 25, would be that God, the judge who must render just verdicts, is the recipient of the ransom. If so, an equal emphasis must be placed on the fact that God is also the originator of the liberating process.")]), _vm._v(" "), _c('p', [_vm._v("As he does in Eph. 1:7 and Col. 1:14, Paul adds that this redemption is “in Christ Jesus.” It is not clear whether Paul means by it that the liberation was accomplished by Christ at the cross or that the liberation occurs “in relation to” Christ, whenever sinners trust Christ."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.230.54",
      "id": "FN.230.54r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")]), _vm._v(" Favoring the latter, however, is the connection of “redemption” with the forgiveness of sins in Eph. 1:7 and Col. 1:14, and 1 Cor. 1:30: “Christ was made … "), _c('i', [_vm._v("our")]), _vm._v(" redemption.” While, then, the “price” connoted by the word “redemption” was “paid” at the cross in the blood of Christ, the redeeming work that the payment made possible is, like justification, applied to each person when he or she believes.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("25")]), _vm._v(" Although the Greek word for “whom” connects v. 25 to v. 24, the connection is so loose that v. 25 may be considered as beginning a new sentence. The focus shifts from human reception of God’s justifying work to God’s initiative in providing for it. Specifically, Paul now unfolds the nature and means of “the redemption that is in Christ Jesus,” showing that this redemption takes place at the will and initiative of God the Father. While the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.231"
    }
  }), _vm._v("persons of God the Father and God the Son must be kept distinct as we consider the process of redemption, it is a serious error to sever the two with respect to the will for redemption, as if the loving Christ had to take the initiative in placating the angry Father. God’s love and wrath meet in the atonement, and neither can be denied or compromised if the full meaning of that event is to be properly appreciated. “Our own justification before God rests on the solid reality that the fulfilling of God’s justice in Christ was at the same time the fulfilling of this love for us.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.231.55",
      "id": "FN.231.55r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" "), _c('p', [_vm._v("The first five Greek words of v. 25 form the main clause of this new sentence, with the series of prepositional phrases and clauses in the rest of v. 25 and v. 26 dependent on it. The verb in this clause could be translated either “propose, plan” (cf. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.REB"
    }
  }, [_vm._v("REB")]), _vm._v(", “designed”) or “display publicly” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NASB"
    }
  }, [_vm._v("NASB")]), _vm._v(")."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.231.56",
      "id": "FN.231.56r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")]), _vm._v(" A good case can be made for the former,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.231.57",
      "id": "FN.231.57r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")]), _vm._v(" but the latter fits better with the background and imagery of the concept Paul alludes to here (see below on "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(") and should probably be preferred."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.231.58",
      "id": "FN.231.58r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")]), _vm._v(" Redemption is “in Christ” in that God “displayed him publicly,” or “set him forth as a sacrifice” on the cross as a "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion.")]), _vm._v(" Nor should it be missed that it is God who thus takes the initiative in the process of redemption—not Christ, and certainly not human beings. As P. T. Forsyth remarks, “The prime doer in Christ’s cross was God. Christ was God reconciling. He was God doing the very best for man, and not man doing his very best for God.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.231.59",
      "id": "FN.231.59r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('p', [_vm._v("What Paul means by designating Christ a "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(" has been the subject of considerable debate."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.231.60",
      "id": "FN.231.60r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")]), _vm._v(" When the use of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.231.61",
      "id": "FN.231.61r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿61")]), _vm._v(" in the Bible is considered, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.232"
    }
  }), _vm._v("a strong case can be made for taking the word as a reference to the OT “mercy seat,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.232.62",
      "id": "FN.232.62r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")]), _vm._v(" the cover over the ark where Yahweh appeared (Lev. 16:2), and on which sacrificial blood was poured. For this is what the word refers to in its one other NT occurrence (Heb. 9:5), as well as in 21 of its 27 "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" occurrences."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.232.63",
      "id": "FN.232.63r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")]), _vm._v(" Particularly significant are the several occurrences of the word in the description in Lev. 16 of the “Day of Atonement” ritual. According to this text, the high priest is to enter the “Holy of Holies” once a year and sprinkle on the mercy seat (= "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(") the blood of a sacrificial victim, thereby “making atonement.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.232.64",
      "id": "FN.232.64r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")]), _vm._v(" In the OT and Jewish tradition, this “mercy seat” came to be applied generally to the place of atonement."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.232.65",
      "id": "FN.232.65r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")]), _vm._v(" By referring to Christ as this “mercy seat,” then, Paul would be inviting us to view Christ as the New Covenant equivalent, or antitype, to this Old Covenant “place of atonement,” and, derivatively, to the ritual of atonement itself. What in the OT was hidden from public view behind the veil has now been “publicly displayed” as the OT ritual is fulfilled and brought to an end in Christ’s “once-for-all” sacrifice. This interpretation, which has an ancient and respectable heritage,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.232.66",
      "id": "FN.232.66r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")]), _vm._v(" has been gaining strength in recent years."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.232.67",
      "id": "FN.232.67r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")]), _vm._v(" It is "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.233"
    }
  }), _vm._v("attractive because it gives to "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(" a meaning that is derived from its “customary” biblical usage, and creates an analogy between a central OT ritual and Christ’s death that is both theologically sound and hermeneutically striking.")]), _vm._v(" "), _c('p', [_vm._v("To be sure, there are objections to taking "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(" as a reference to the “mercy seat.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.233.68",
      "id": "FN.233.68r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")]), _vm._v(" Some claim, for instance, that the imagery would have been foreign to the Gentile Christian church in Rome; and Paul would hardly have used imagery that he knew they would fail to understand."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.233.69",
      "id": "FN.233.69r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")]), _vm._v(" However, arguments based on what the Gentile congregation in Rome would, or would not, have been familiar with are precarious. Paul’s letters furnish abundant proof that he expected his Gentile readers to be fully conversant with the OT. Surely he could expect his Gentile readers in Rome to have some knowledge of the Day of Atonement ritual and the significance within it of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion.")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.233.70",
      "id": "FN.233.70r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.234"
    }
  }), _vm._v("In fact, we do not find anything that would render the interpretation of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(" against the background of the OT mercy seat improbable. Before drawing conclusions, however, other alternatives must be considered.")]), _vm._v(" "), _c('p', [_vm._v("While Deissmann has shown that "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(" usually means “means of propitiation” in ordinary Greek,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.234.71",
      "id": "FN.234.71r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")]), _vm._v(" C. H. Dodd has argued that the word in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" means “means of expiation,” and he accordingly opts for this translation in Rom. 3:25. “Propitiation” has reference to the turning away of wrath, and the appeasement of the “wrath of the gods” by various means is a frequent theme in Greek literature. This theme Dodd finds totally absent in the Bible. The verb cognate to "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(" in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" has as its object sin, not God. The idea conveyed by the word and its cognates is thus, Dodd argues, the “covering,” or forgiving, of sins, not the appeasing of God’s wrath."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.234.72",
      "id": "FN.234.72r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")]), _vm._v(" Others, while not endorsing all Dodd’s conclusions, agree that reference to God’s wrath should be eliminated from the word, and translate generally “means of atonement,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.234.73",
      "id": "FN.234.73r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")]), _vm._v(" or “atoning,” or “expiatory sacrifice.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.234.74",
      "id": "FN.234.74r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.235"
    }
  }), _vm._v("But Dodd is almost certainly wrong on this point. The OT frequently connects the “covering,” or forgiving, of sins with the removal of God’s wrath."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.235.75",
      "id": "FN.235.75r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")]), _vm._v(" It is precisely the basic connotation of “propitiate” that led the translators of the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" to use the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilask-")]), _vm._v(" words for the Hebrew words denoting the covering of sins."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.235.76",
      "id": "FN.235.76r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")]), _vm._v(" This is not, however, to deny the connotation “expiation”; the OT cult serves to “wipe away” the guilt of sin at the same time as—and indeed, because—the wrath of God is being stayed."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.235.77",
      "id": "FN.235.77r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")]), _vm._v(" When to the linguistic evidence we add the evidence of the context of Rom. 1–3, where the wrath of God is an overarching theme (1:18; cf. 2:5), the conclusion that "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(" includes reference to the turning away of God’s wrath is inescapable.")]), _vm._v(" "), _c('p', [_vm._v("This propitiation is, of course, altogether different from pagan notions of propitiation. First, as we have seen, the biblical conception of the wrath of God is far removed from the pagan picture of a capricious and often vindictive deity. God’s wrath is the inevitable and necessary reaction of absolute holiness to sin. Second, in contrast to the secular religious tradition, it is God himself who initiates the propitiatory offering. “In the heathen "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.236"
    }
  }), _vm._v("view expiation renders the gods willing to forgive; in the Biblical view expiation enables God, consistently with his holiness, to do what he was never unwilling to do. In the former view sacrifice changes the sentiment of the gods toward men; in the latter it affects the consistency of his procedure in relation to sin.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.236.78",
      "id": "FN.236.78r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" "), _c('p', [_vm._v("Finally, we must decide whether Paul intends to present this wrath-averting sacrifice of Christ against the background of the typology of the mercy seat. Our main reason for hesitating to find allusion to the mercy seat is the lack of evidence for an early Christian or Jewish Greek tradition in which "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(" was given the symbolic importance this interpretation suggests."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.236.79",
      "id": "FN.236.79r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")]), _vm._v(" Nevertheless, in this, as in so many other areas, Paul may have been the theological innovator; and the lexical data, combined with the theological appropriateness of the image, make it likely that Paul intends such an allusion. Christ, Paul implies, now has the place that the “mercy seat” had in the Old Covenant: the center and focal point of God’s provision of atonement for his people. Since this atonement takes place by means of Christ’s death as a sacrifice, and the word "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(" includes reference to propitiation, translations such as “means of propitiation”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.236.80",
      "id": "FN.236.80r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")]), _vm._v(" and “propitiatory sacrifice”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.236.81",
      "id": "FN.236.81r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")]), _vm._v(" are not inaccurate. But they may be too restrictive. “Mercy seat” would be all right if the broader theological connotations of the phrase were obvious; but, considering the breadth of the concept to which the term refers, the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NIV"
    }
  }, [_vm._v("NIV")]), _vm._v(" and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NRSV"
    }
  }, [_vm._v("NRSV")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.236.82",
      "id": "FN.236.82r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿82")]), _vm._v(" “sacrifice of atonement” is as good as we can do.")]), _vm._v(" "), _c('p', [_vm._v("In a piling up of prepositional phrases that are often seen as indicative of a confessional or hymnic style, Paul now expands on the significance and implications of God’s setting forth Christ as the New Covenant “propitiatory.” “Through faith” is not likely to modify “set forth,” since faith was not the instrument through which God “set forth” Christ as "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion.")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.236.83",
      "id": "FN.236.83r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")]), _vm._v(" Rather, the phrase modifies "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v(" and indicates the means by which individuals appropriate the benefits of the sacrifice. It is "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.237"
    }
  }), _vm._v("harder to know whether “in his blood” indicates the object of “faith”—“faith in his blood” (cf. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.KJV"
    }
  }, [_vm._v("KJV")]), _vm._v("),"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.237.84",
      "id": "FN.237.84r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")]), _vm._v(" modifies the verb “set forth”—“through his blood God has presented him,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.237.85",
      "id": "FN.237.85r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")]), _vm._v(" or modifies "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion—")]), _vm._v("“a propitiation in blood” (note the reversal of terms in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NASB"
    }
  }, [_vm._v("NASB")]), _vm._v(": “a propitiation in his blood through faith”)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.237.86",
      "id": "FN.237.86r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")]), _vm._v(" But Paul never elsewhere makes Christ’s blood an object of faith,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.237.87",
      "id": "FN.237.87r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")]), _vm._v(" so the latter is preferable. “In his blood” singles out Christ’s blood as the means by which God’s wrath is propitiated."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.237.88",
      "id": "FN.237.88r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")]), _vm._v(" As in several other texts where Christ’s blood is the means through which salvation is secured (Rom. 5:9; Eph. 1:7; 2:13; Col. 1:20), the purpose is to designate Christ’s death as a sacrifice."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.237.89",
      "id": "FN.237.89r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" "), _c('p', [_vm._v("The third prepositional phrase in the series indicates the purpose for which God “set forth Christ as a sacrifice of atonement”: “for"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.237.90",
      "id": "FN.237.90r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿90")]), _vm._v(" a demonstration"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.237.91",
      "id": "FN.237.91r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿91")]), _vm._v(" of his righteousness because of the passing over of sins committed beforehand in the forbearance of God.” Just what Paul means by this phrase is disputed, the pivotal issue being the meaning of “his righteousness.” Scholars have proposed many interpretations, but there are two general approaches. The first takes “righteousness” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(dikaiosynē)")]), _vm._v(" to designate what we might call an aspect of God’s character, whether this be his “justice” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(iustitia distributiva),")]), _vm._v(" his impartiality and fairness, or his acting in accordance with his own character and for his own glory. The whole clause would, then, be interpreted along the lines of the following paraphrase: “in order to demonstrate [or show] that God is just, acting in accordance with his own character, [which was necessary] because he had passed over sins committed before, in "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.238"
    }
  }), _vm._v("the time of his forbearance.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.238.92",
      "id": "FN.238.92r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")]), _vm._v(" The second interpretation understands “righteousness” here to be God’s saving, covenant faithfulness, which requires that the clause as a whole be translated something like “in order to manifest his saving faithfulness through his forgiving of sins committed before, in the time of his forbearance.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.238.93",
      "id": "FN.238.93r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")]), _vm._v(" On the first view, this clause makes an important contribution to our understanding of the “internal” mechanism of the atonement, explaining the necessity of Christ’s propitiating work in terms of the requirements of God’s holy character. God’s past restraint in punishing sins with the full measure of punishment they deserved calls into question his fair and impartial “justice,” or holiness, creating the need for this justice to be “satisfied,” a satisfaction rendered by the propitiatory sacrifice of Christ. On the second view, the clause ties God’s work in Christ to his fulfilling of his covenant promises. God now fulfills those salvific promises by putting forth Christ as the means by which sins are forgiven. While the second view has been preferred by most contemporary scholars, there are sound reasons for adopting the first. Since the interpretation of “his righteousness” is so dependent on the meaning of other key words in the clause, we will begin with these words and come back to this phrase.")]), _vm._v(" "), _c('p', [_vm._v("Especially critical is the interpretation of the prepositional phrase “because of the passing over of sins committed beforehand.” Those who argue that “his righteousness” refers to God’s covenant faithfulness insist that this translation of the phrase is incorrect. It should, they claim, be rendered something like “through [or for the sake of] the forgiveness of sins committed beforehand.” The phrase would then express the means (or purpose) by which God has demonstrated his saving faithfulness: by acting to secure forgiveness for the sins committed under the Old Covenant."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.238.94",
      "id": "FN.238.94r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")]), _vm._v(" But this rendering has insufficient lexical support. The word we translate “passing over” does not mean “forgiveness,” but, when applied to legal charges or sins, “postponement of punishment” (“pretermission”) or “neglect” of prosecution."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.238.95",
      "id": "FN.238.95r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")]), _vm._v(" Nor "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.239"
    }
  }), _vm._v("is it likely that the preposition "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dia")]), _vm._v(" can here be translated “through.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.239.96",
      "id": "FN.239.96r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")]), _vm._v(" The preposition could have virtually a telic meaning (“with a view to”),"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.239.97",
      "id": "FN.239.97r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")]), _vm._v(" but this makes little sense with the word “passing over.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.239.98",
      "id": "FN.239.98r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")]), _vm._v(" The translation “through [or for the purpose of] forgiveness of sins” must, then, be rejected as requiring strained and unusual meanings for too many words."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.239.99",
      "id": "FN.239.99r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")]), _vm._v(" But this further makes it very difficult for “his righteousness” to refer to God’s saving faithfulness. For it makes no sense for Paul to say that “passing over” former sins was the "), _c('i', [_vm._v("reason")]), _vm._v(" for God’s demonstration of his saving faithfulness.")]), _vm._v(" "), _c('p', [_vm._v("But what are these “former sins” to which Paul is referring? The phrase at the beginning of v. 26 points toward an answer. “In the forbearance of God” should be connected with “passing over,” and in light of Paul’s only other use of “forbearance” (Rom. 2:4),"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.239.100",
      "id": "FN.239.100r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")]), _vm._v(" it will refer to the period of time "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.240"
    }
  }), _vm._v("before the cross (cf. also Acts 14:16; 17:30). The sins “committed beforehand” will not, then, be sins committed before conversion, or baptism,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.240.101",
      "id": "FN.240.101r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")]), _vm._v(" but before the new age of salvation. This does not mean that God failed to punish or “overlooked” sins committed before Christ; nor does it mean that God did not really “forgive” sins under the Old Covenant."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.240.102",
      "id": "FN.240.102r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")]), _vm._v(" Paul’s meaning is rather that God “postponed” the full penalty due sins in the Old Covenant, allowing sinners to stand before him without their having provided an adequate “satisfaction” of the demands of his holy justice (cf. Heb. 10:4).")]), _vm._v(" "), _c('p', [_vm._v("In view of this, it is clear that “his righteousness” must have reference to some aspect of God’s character that might have been called into question because of his treating sins in the past with less than full severity, and that has now been demonstrated in setting forth Christ as “the propitiatory.” “God’s righteousness” in v. 25 (and 26) must, then, mean something different than it does in vv. 21–22, where the process by which God justifies sinful people is designated."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.240.103",
      "id": "FN.240.103r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")]), _vm._v(" Ridderbos thinks Paul refers to God’s punitive righteousness,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.240.104",
      "id": "FN.240.104r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")]), _vm._v(" Piper to God’s acting always to uphold his glory,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.240.105",
      "id": "FN.240.105r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")]), _vm._v(" but we prefer a more general reference to God’s “consistency” in always acting in accordance with his own character."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.240.106",
      "id": "FN.240.106r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("26")]), _vm._v(" We have already dealt with the first phrase of this verse in conjunction with the last clause in v. 25. The next part of the verse seems unnecessarily to repeat what Paul has already said in v. 25: “for a demonstration"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.240.107",
      "id": "FN.240.107r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿107")]), _vm._v(" of his righteousness at the present time.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.240.108",
      "id": "FN.240.108r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")]), _vm._v(" Some think that the phrase "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.241"
    }
  }), _vm._v("expresses the ultimate purpose of vv. 25b–26a: God let sins go unpunished, in his forbearance, “with a view to” demonstrating his righteousness at the present time."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.241.109",
      "id": "FN.241.109r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")]), _vm._v(" But it is better to take the clause as parallel to “for a demonstration …” in v. 25. It resumes the topic of the demonstration of God’s righteousness after the intervening qualifiers and adds the important point that this demonstration has significance not only for the past but also for the present age."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.241.110",
      "id": "FN.241.110r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")]), _vm._v(" A reference back to “but now” at the beginning of the paragraph is obvious, as Paul focuses again on the time after Christ’s coming as the climactic, eschatological age of salvation history.")]), _vm._v(" "), _c('p', [_vm._v("There are only two ways to make sense of the connection between the final clause of the verse and the preceding context. Either Paul is indicating the ultimate purpose or result"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.241.111",
      "id": "FN.241.111r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿111")]), _vm._v(" of the sentence he began in v. 25—“God set forth Christ as a propitiation in order that [or with the result that] he is just and the justifier of the one who has faith in Jesus”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.241.112",
      "id": "FN.241.112r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")]), _vm._v("—or it explains the immediately preceding clause—“for a demonstration of his righteousness at the present time, in order that he might show that he is just and the justifier of the person who has faith in Jesus.” Despite its somewhat weak support in the commentaries, this last rendering should be preferred, because it preserves what seems to be a natural connection between “the present time” and “justifying the one who has faith in Jesus.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.241.113",
      "id": "FN.241.113r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")]), _vm._v(" On this view, the two purpose clauses in vv. 25 and 26—both beginning “for a demonstration”—are parallel modifiers of “set forth,” the former focusing on how the propitiatory sacrifice of Christ enabled God to maintain his righteous character in postponing punishment of sins in the past, the latter showing how this same sacrifice "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.242"
    }
  }), _vm._v("preserved God’s righteous character as he justifies those who, in this age of salvation, place their faith in Jesus. This being so, it is likely that “the justifier”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.242.114",
      "id": "FN.242.114r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")]), _vm._v(" is not coordinate with “just”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.242.115",
      "id": "FN.242.115r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")]), _vm._v("—“just "), _c('i', [_vm._v("and")]), _vm._v(" justifying,” nor instrumental to it—“just "), _c('i', [_vm._v("by means of")]), _vm._v(" justifying,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.242.116",
      "id": "FN.242.116r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")]), _vm._v(" but concessive—“just "), _c('i', [_vm._v("even in")]), _vm._v(" justifying.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.242.117",
      "id": "FN.242.117r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")]), _vm._v(" Paul’s point is that God can maintain his righteous character (“his righteousness” in vv. 25 and 26) even while he acts to justify sinful people (“God’s righteousness” in vv. 21 and 22) because Christ, in his propitiatory sacrifice, provides full satisfaction of the demands of God’s impartial, invariable justice."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.242.118",
      "id": "FN.242.118r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")]), _vm._v(" To be sure, this way of viewing the atonement is out of fashion these days, frequently being dismissed as involving ideas completely foreign to the biblical teaching about God’s sovereignty and love. But whatever the mistakes of Anselm of Canterbury, whose famous treatise "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Cur Deus Homo")]), _vm._v(" (“Why God Became Man”) is widely regarded as the fountainhead of this approach, his emphasis on the divine character as incapable of dismissing sin lightly is a vital component in the biblical doctrine of God. Those who ignore or minimize the problem inherent in a holy God accepting sinners may well heed Anselm’s own warning: “You have not yet considered the weight of sin.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.242.119",
      "id": "FN.242.119r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v(" "), _c('p', {
    staticClass: "psec"
  }, [_vm._v("Luther called this paragraph “the chief point … of the whole Bible” (see the introduction to his paragraph) because it focuses on what Luther thought was the heart of the Bible: justification by faith. Luther believed that this “article” was vital: “if that article stands, the church stands; if it falls, the church falls.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.242.120",
      "id": "FN.242.120r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")]), _vm._v(" Later Lutherans coined the slogan “the article by which the church stands or falls” to highlight the central role that they accorded this doctrine. In Luther’s day, of course, “justification by faith” was a polemical thrust against a Roman Catholic teaching that insisted on the place of human cooperation in the grace of justification. Hence to the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("sola fide")]), _vm._v(" of the Reformers was added "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("sola gratia—")]), _vm._v("“by grace alone.” With these phrases, the Reformers expressed their conviction that justification is, from first to last, a matter of God’s own doing, to which human beings must respond but to which they can add nothing.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.243"
    }
  }), _vm._v("Despite important and welcome moves toward reconciliation between Protestants and Roman Catholics, the division between the two groups over justification remains. In an age that minimizes doctrine, there is a danger that this difference will be too easily swept under the carpet. But it is a significant one, affecting one’s understanding of salvation, the sacraments, assurance, and other matters both doctrinal and practical.")]), _vm._v(" "), _c('p', [_vm._v("The Reformation doctrine of justification by faith is also being challenged from other fronts these days. Chief among them, perhaps, is the tendency to read Paul’s justification by faith as having primary focus on the inclusion of the Gentiles. The Reformers’ justification by faith, referring to the acceptance before a holy God of a sinful individual through that individual’s believing, becomes the acceptance of the Gentiles within the people of God through Christ’s faithfulness or act of believing."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.243.121",
      "id": "FN.243.121r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")]), _vm._v(" As I suggest in my comments on a number of passages (cf. 3:20, 3:22, and the excursuses after 1:17 and 3:20), I think this general tendency both exegetically indefensible and theologically dangerous. Our era is one that—quite rightly—manifests deep concern for social issues. Interpreting Paul’s gospel in social terms (e.g., as having primary focus on the inclusion of Gentiles along with Jews in the people of God) is correspondingly very attractive. But for all Paul’s very vital interest in the unity of the people of God, he is even more vitally concerned about the relationship of the individual Jew or Gentile to the Lord of history.")]), _vm._v(" "), _c('p', {
    staticClass: "ch",
    attrs: {
      "id": "BODY4.1.2"
    }
  }, [_vm._v("2. “By Faith Alone” (3:27–4:25)")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In 3:27–4:25, Paul expounds the great theological thesis of 3:21–26. Or, to be more accurate, he expounds one key element in that thesis. For we hear no more in 3:27–4:25 about the atonement, or the demonstration of God’s righteousness, or the provision for sins under the Old Covenant. Rather, Paul concentrates on the vital theme stated in v. 22: “the righteousness of God through faith in Jesus Christ to all who believe.” Faith is the topic in every paragraph of this section of the letter, as Paul uses a series of antitheses to draw out the nature and implications of faith as the sole means of justification. Faith is contrasted with “works of the law” (3:28), “works” (4:1–8), circumcision (4:9–12), the law (4:13–16), and “sight” (4:17–22). With these contrasts Paul enunciates what has become a hallmark of the Reformation teaching: "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("sola fide—")]), _vm._v("that “faith alone” is the means by which a person can be brought into relationship with the God of the Bible. "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Sola fide,")]), _vm._v(" Paul argues in this "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.244"
    }
  }), _vm._v("section, is necessary in order to maintain "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("sola gratia:")]), _vm._v(" “by grace alone.” But it is also necessary in order to ensure that Gentiles have equal access with Jews to the one God. The inclusion of Gentiles in the people of God has been God’s plan all along, as his dealings with Abraham demonstrate. The revelation of God’s righteousness “apart from the law” (v. 21) has now opened up this possibility in a way that was not the case before. This concern with the inclusion of the Gentiles is thus also an important theme in this section; but, contrary to many contemporary scholars, who are reacting to what they perceive to be an excessive concern with the individual and his or her relationship to God in traditional theology, it is not the main theme. The inclusion of the Gentiles within the people of God continues to crop up—3:29–30; 4:9–12, 16–17—but only as one motif within the larger argument.")]), _vm._v(" "), _c('p', [_vm._v("The antitheses in this section reveal its polemical thrust. Paul is once again “arguing” with a Jewish or Jewish-Christian viewpoint, contesting the importance of the law (3:27–28; 4:13–15), works (4:2–8), and circumcision (4:9–12). Indicative of this thrust is the return to the “dialogical” style of 2:1–5, 17–19; 3:1–8. On the other hand, in the balance that so characterizes Paul’s presentation of his gospel in Romans, he is at pains to maintain continuity with the OT and with Judaism. Justification by faith is nothing more than what the OT itself teaches (chap. 4, passim); faith “establishes” the law (3:31); and even circumcision, while no longer the necessary sign of those who belong to God, is upheld as valid for Jews (4:11–12). These positive remarks about OT and Jewish institutions stand in marked contrast to the somewhat parallel passage in Galatians (chap. 3), where Paul’s polemical concerns force him to take a more one-sided slant. In Romans, however, Paul is intent on showing how his gospel breaks the boundaries of the Old Covenant while at the same time standing in continuity with it; continuity within discontinuity is his theme. Such balance was necessary if the Romans were to understand and appreciate Paul’s gospel as a message that meets the needs of all people.")]), _vm._v(" "), _c('p', [_vm._v("While the preoccupation with Abraham in chap. 4 sets apart that chapter from the last paragraph of chap. 3, the two sections are closely related. In fact, an impressive degree of parallelism between the two is evident:"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.244.1",
      "id": "FN.244.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "tdul"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.245"
    }
  }), _vm._v("Boasting is excluded (3:27a)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("Abraham has no right to boast (4:1–2)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tdulf"
  }, [_vm._v("… because one is justified by faith, not works of the law (3:27b–28)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdulf"
  }, [_vm._v("… because Abraham was justified by faith, not works (4:3–8)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tdulf"
  }, [_vm._v("Circumcised and uncircumcised are united under the one God through faith (3:29–30)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdulf"
  }, [_vm._v("Circumcised and uncircumcised are united as children of Abraham through faith (4:9–17)")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Naturally, the much longer chap. 4 introduces a number of points not found in 3:27–31,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.245.2",
      "id": "FN.245.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿2")]), _vm._v(" but the similarity in general theme and development is striking. We may, then, view 3:27–31 as the initial statement of the theme, with chap. 4 as its elucidation and elaboration."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.245.3",
      "id": "FN.245.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "dh",
    attrs: {
      "id": "BODY4.1.2.1"
    }
  }, [_vm._v("a. “By Faith Alone”: Initial Statement (3:27–31)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("27")]), _vm._v("Where then is boasting? It is excluded. Through what law? Of works? No, but through the law of faith. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("28")]), _vm._v("For"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.245.4",
      "id": "FN.245.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿4")]), _vm._v(" we reckon that a person is justified by faith apart from works of the law. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("29")]), _vm._v("Or is God the God of Jews only? Is he not also the God of Gentiles? Yes, he is God also of the Gentiles, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("30")]), _vm._v("since there is one God, who will justify the circumcision on the basis of faith and the uncircumcision through that faith. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("31")]), _vm._v("Do we then nullify the law through faith? By no means! Rather, we establish the law.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.246"
    }
  }), _vm._v("Paul moves quickly through several implications of and arguments for justification by faith. He begins by showing how justification by faith excludes any possibility of boasting on the part of Jews (vv. 27–28). The next two verses provide further reason for accepting the principle that justification must be by faith with no admixture of “works of the law”; only so can God truly be the God of Gentiles as well as Jews. Finally, in v. 31, Paul responds briefly to a Jewish objection to his stress on faith; no, he argues, faith does not nullify but “establishes” the law—enables it to be truly fulfilled. The style, as in 2:1–5, 17–29 and 3:1–8, reflects the diatribe method of argumentation, with its question-and-answer format. As in the earlier sections, it is difficult to say—and perhaps not all that important—whether we have here a “real” dialogue between Paul and a Jewish interlocutor,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.246.5",
      "id": "FN.246.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" or whether Paul himself is responsible for posing questions to himself as a means of making his points."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.246.6",
      "id": "FN.246.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("27")]), _vm._v(" The question “Where then is boasting?” with its answer “It is excluded”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.246.7",
      "id": "FN.246.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" draws an inference from vv. 21–26. “Boasting,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.246.8",
      "id": "FN.246.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" of course, is a sin common to all people—it reflects the pride that is at the root of so much human sinfulness. But Paul is probably thinking here particularly of Jews and their boasting. This is suggested by his elaboration in terms of the “law” in vv. 27b–28, by his dialogical style—the “Jew” has been his dialogue partner earlier (cf. 2:17), and by the focus on Jew and Gentile in vv. 29–30. What is the nature of this boasting? and why is it wrong? One interpretation holds that Paul is thinking of the pride of the Jews in their special covenant relationship to God (cf. 2:17). Such pride, Paul would then be arguing, has now been ruled out by the revelation of God’s righteousness apart from that covenant and its law."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.246.9",
      "id": "FN.246.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" There is considerable truth in this view, as is clear from the Jewish emphasis throughout these chapters and from Paul’s stress that God has now revealed his righteousness “apart from the law” (3:27). But this “salvation-historical” explanation does not, in itself, go far enough. Paul’s reason for "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.247"
    }
  }), _vm._v("excluding boasting has to do with a contrast between faith and works (vv. 27b–28)—two kinds of human response to God (reasons for not limiting “works of the law” to Jewish covenant privileges will be given below). And this is confirmed by the parallel teaching about Abraham in chap. 4. The hypothetical basis for Abraham’s boasting is not simply covenant “identity markers” but “works” in a general sense. Moreover, Paul’s use of Abraham as a key example shows also that it is not just with the coming of Christ that boasting becomes wrong;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.247.10",
      "id": "FN.247.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" Abraham, many centuries before Christ, had no cause to boast either.")]), _vm._v(" "), _c('p', [_vm._v("The root issue here, then, is not salvation-historical, but anthropological. It is not the Jew’s pride in a covenant relationship with God, but the pride in accomplishments, the tendency for the Jew to think that his obedience to the law constituted some kind of claim on God, that Paul rejects."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.247.11",
      "id": "FN.247.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" This does not mean, however, that the very doing of the law was wrong because it involved sinful, boastful presumption."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.247.12",
      "id": "FN.247.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" There is nothing at all wrong with doing the law, according to Paul. The problem, rather, is when doing the law is regarded as an achievement on the basis of which a relationship with God could be established or maintained. This is wrong because justification can come only by faith: not only now that Christ has been revealed (vv. 21–24)—although this makes it even clearer—but in the past also (chap. 4). This is not to say, either, that all Jews were prone to such a “legalistic” attitude. Certainly, the centrality of the law in the Jewish religion rendered Jews very susceptible to such a tendency; but all people, being fallen, exhibit the same tendency: Greeks, boasting in their wisdom (cf. 1 Cor. 1:19–31); Americans, boasting in their “American way of life”; and all too many Christians, boasting in their “good deeds” instead of in the grace of God.")]), _vm._v(" "), _c('p', [_vm._v("Paul’s explanation for the exclusion of boasting, as we have seen, rests on a contrast between “works” and “faith” (v. 27b). What is striking about this contrast is that Paul formulates it with the help of the word “law” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(nomos):")]), _vm._v(" “Through what "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos")]), _vm._v(" [is boasting excluded]? [Through the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos")]), _vm._v("]"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.247.13",
      "id": "FN.247.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" of works? No, but through the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos")]), _vm._v(" of faith.” What is his purpose in using this word here? Paul’s normal usage of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos")]), _vm._v(" would suggest that he uses the word throughout the verse with reference to the law of Moses, the torah. Paul would then be contrasting two different ways of understanding, or using, the law of Moses: understood simply in terms of “works,” it could lead to boasting; but "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.248"
    }
  }), _vm._v("understood in terms of “faith,” it excludes all such boasting."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.248.14",
      "id": "FN.248.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" Advocates of this view sometimes point to the word we have translated “what?” as important support for their view. For the “literal” meaning of this word is “what kind of?” and this qualitative connotation supports the idea that Paul is asking here about contrasting qualities of the same law."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.248.15",
      "id": "FN.248.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" But the “literal” translation is, in fact, not clearly dominant in the NT, where the translation “what?” receives strong support."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.248.16",
      "id": "FN.248.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" On either translation, it is straining the wording to think that Paul is referring to two perspectives on the same law rather than to two different laws.")]), _vm._v(" "), _c('p', [_vm._v("But an even more serious objection to this interpretation is the close relationship between the law of Moses and faith that it assumes. For such a positive relationship between these two contradicts both the movement of this passage and Paul’s larger teaching about the law. In both 3:21–26 and 3:28, the faith that gains a standing with God is explicitly distanced from the Mosaic law (“apart from the law”; “apart from works of the law”). It is just this distance that gives rise to the question in v. 31: “Do we then nullify the law through faith?” This question does not make sense unless Paul has, in this context, fully separated “faith” from the law of Moses. And this same careful distinction between believing and “doing” (the law, works of the law) is "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.249"
    }
  }), _vm._v("maintained throughout Romans (cf. 2:25–29; 3:20; 4:2–8; 9:31–10:8) and the Pauline writings (cf. esp. Gal. 3:12). An allusion to a connection—however it is viewed—between faith and the Mosaic law in v. 27 would run quite counter to this clear principial distinction. It is our faith, “apart from works of the law” (v. 28), that rules out of court any possibility of boasting—not a new way of looking at the law (cf. also the plain antitheses in 4:2–6 and 13–15).")]), _vm._v(" "), _c('p', [_vm._v("A second interpretation is, then, to be preferred: that Paul is contrasting two different “laws.” On this view, the word "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos,")]), _vm._v(" in both its actual occurrences in the verse, has a metaphorical sense: “principle,” or “rule.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.249.17",
      "id": "FN.249.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" Some scholars think, then, that there is no direct allusion to the law of Moses at all here; Paul simply contrasts the “principles” of works and faith."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.249.18",
      "id": "FN.249.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" But Paul connects the Mosaic law and “works” too often in Romans (cf. 2:6–16, 25–27; 3:20) to make it possible to eliminate reference here to the torah. We take it, then, that "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos")]), _vm._v(" in Paul’s question, while meant to have a general reference—“what ‘rule’ or ‘system of demands’ excludes boasting?”—would naturally bring to mind "), _c('i', [_vm._v("the")]), _vm._v(" law, the torah. Paul then adds the contrasting modifiers to make clear his point: no, it is not through the torah, that law which demands works, through which boasting is excluded; it is through the “rule” of faith, the “ordinance” or “demand” of God for faith as the basis for justification (v. 28)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.249.19",
      "id": "FN.249.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" Rather than being entirely metaphorical, then, Paul’s use of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.250"
    }
  }), _vm._v("embodies a “play on words,” in which the characteristic demand of the Mosaic covenant—works—is contrasted with the basic demand of the New Covenant (and of the OT, broadly understood; cf. chap. 4)—faith.")]), _vm._v(" "), _c('p', [_vm._v("Paul’s point is that the narrow focus of most of his fellow Jews on the Mosaic law as the system within which their relationship to God was established gives rise to an implicit “boast” in human achievement; what a person does in obedience to the law becomes, in some sense and to varying degrees, critical to one’s “righteousness.” Once it is seen, however, that God’s righteousness comes to people “apart from the law,” there can be no more cause for any pride in human achievement."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.250.20",
      "id": "FN.250.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("28")]), _vm._v(" In this verse Paul explains"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.250.21",
      "id": "FN.250.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿21")]), _vm._v(" “the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("nomos")]), _vm._v(" of faith.” It is a “rule” or “principle” pertaining to faith that “a person"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.250.22",
      "id": "FN.250.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿22")]), _vm._v(" is justified by faith"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.250.23",
      "id": "FN.250.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿23")]), _vm._v(" apart from works of the law.” Paul here promulgates no new rule; the first person plural “we reckon” probably indicates that he assumes that his readers would join him in this assessment."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.250.24",
      "id": "FN.250.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" Paul’s concern to meet Jewish views is evident in his addition “apart from works of the law.” As in 3:20, what is meant is not certain kinds of works, or works viewed in a certain light, but anything a person does in obedience to the law and, by extrapolation, anything a person does. This being the case, Luther’s famous addition of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("sola")]), _vm._v(" (“alone”) to "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("fide")]), _vm._v(" (“faith”)—in which he was preceded by others, including Thomas Aquinas"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.250.25",
      "id": "FN.250.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿25")]), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.251"
    }
  }), _vm._v("—brings out the true sense intended by Paul. A serious erosion of the full significance of Paul’s gospel occurs if we soften this antithesis; no works, whatever their nature or their motivation, can play any part in making a sinner right with God.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("29–30")]), _vm._v(" “Or”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.251.26",
      "id": "FN.251.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" introduces the alternative to the principle set forth in v. 28: if justification is by works of the law, then only those “in the law” can be justified, and God becomes the God of Jews only. Paul rejects this alternative with the question, “Is he not also the God"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.251.27",
      "id": "FN.251.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿27")]), _vm._v(" of Gentiles?” To this question Paul gives the answer already implied by the form of the question:"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.251.28",
      "id": "FN.251.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" “Yes, he is God also of the Gentiles.” In v. 30, Paul both explains why"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.251.29",
      "id": "FN.251.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿29")]), _vm._v(" God must be God of the Gentiles as well as of the Jews and draws an implication from that truth. The explanation comes in the main clause: “there is one God.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.251.30",
      "id": "FN.251.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" Paul takes one of the most basic of Jewish beliefs, monotheism, and turns it against Judaism. The “oneness” of God was confessed by the pious Jew every day: “the "), _c('span', {
    staticClass: "tetr"
  }, [_vm._v("LORD")]), _vm._v(" our God is one "), _c('span', {
    staticClass: "tetr"
  }, [_vm._v("LORD")]), _vm._v("” (Deut. 6:4). Yet if this is so, then God must be God of the Gentiles; else they would be left with no god. To be sure, Jews also believed that God was God of the whole world. But the limitations they placed upon this concept illustrate the radicality of Paul’s argument. For, in Judaism, God was the God of Gentiles only by virtue of his creative work, while only the Jews enjoy any meaningful relationship with God; this is expressed in later Jewish text: “I am God over all that came into the world, but I have joined my name only with you [Israel]; I am not called the God of the idolaters, but the God of Israel.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.251.31",
      "id": "FN.251.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(" Only by accepting the torah could Gentiles hope to become related to God in the same way as Jews. In this paragraph, and in many other places in Romans, Paul makes clear that the torah no longer functions as the “dividing wall” between those who are outside and those who are inside the sphere of God’s people."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.251.32",
      "id": "FN.251.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(" In the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.252"
    }
  }), _vm._v("OT, while the law was not the means of salvation, it did function to “mark out” the people of God; and in Judaism, it became an impenetrable barrier. But for Paul monotheism, as he has come to see it in Christ, means that there can be no such barrier; all must have equal access to God, and this can be guaranteed only if faith, not works in obedience to the Jewish law, is made the “entrance requirement.”")]), _vm._v(" "), _c('p', [_vm._v("Paul states this radical implication of monotheism in a relative clause: “who will justify"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.252.33",
      "id": "FN.252.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿33")]), _vm._v(" the circumcision on the basis of faith and the uncircumcision through that"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.252.34",
      "id": "FN.252.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿34")]), _vm._v(" faith.” The variation in prepositions in Paul’s description of the faith of the circumcised (“"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("ek")]), _vm._v(" faith”) and that of the uncircumcised (“"), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("dia")]), _vm._v(" faith”) has stimulated the ingenuity of commentators for years."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.252.35",
      "id": "FN.252.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" But none of the suggested distinctions makes very good sense; the change in prepositions is probably simply a stylistic variation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.252.36",
      "id": "FN.252.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("31")]), _vm._v(" The function of this verse in the context can be determined only after the meaning of Paul’s assertion that “faith establishes the law” has been decided. This assertion comes in response to the question, raised by Paul himself (“we”), but undoubtedly reflecting an objection he had heard frequently as he preached to Jews: “Do we then nullify"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.252.37",
      "id": "FN.252.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿37")]), _vm._v(" the law through faith?” How would faith nullify "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.253"
    }
  }), _vm._v("the law? Through Paul’s emphasis on faith “alone,” to the exclusion of “works of the law,” in justification. The polemical situation forced Paul to harp on the inadequacy of works and the limited, and passing, importance of the Mosaic law; and this gave to his preaching an “anti-law” flavor. But, as on other occasions when Paul faces such an objection (cf. Rom. 7:7), he responds with a forthright denial: “By no means!” He then follows this up with a counterassertion: “Rather,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.253.38",
      "id": "FN.253.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" we establish the law.” That Paul affirms here a continuing role for the law, despite its playing no part in justification, is clear. But what role Paul may intend for the law is disputed.")]), _vm._v(" "), _c('p', [_vm._v("The main possibilities are three, according to whether Paul views the law as testifying, convicting, or commanding.")]), _vm._v(" "), _c('p', [_vm._v("(1) The first is the most popular."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.253.39",
      "id": "FN.253.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" Its advocates point to 3:19 and 3:21 for evidence that Paul in this context uses “law” broadly as a reference to Scripture. And, in both 3:21 and chap. 4 (Gen. 15:6), Paul affirms just this “testifying” role of the law in relationship to his teaching of justification by faith. While, then, it is faith, not the law, that justifies, this stress on faith “establishes” the law by setting forth that to which the law bears witness. While a “testifying” role of the OT is plainly asserted in this context, this interpretation suffers from two major problems. First, the connection between v. 31b and chap. 4, on which so much rests, is questionable. Had this been the function of v. 31b, we would have expected chap. 4 to begin with “for”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.253.40",
      "id": "FN.253.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" rather than with “therefore.” A second objection is more serious. That Paul sees in the OT a witness to his teaching about "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.254"
    }
  }), _vm._v("justification by faith is clear. But when denoting that function of the OT, he uses “the law and the prophets” (v. 21) or the “Scripture” (Gal. 3:8). Nowhere does he use “law” by itself to indicate this witnessing role of the OT. Even in Rom. 4, “law” is used in a negative sense and is not linked with the “witness” of Gen. 15:6. Perhaps most significant is 4:3, which introduces the quotation of this verse by asking, not “What does the ‘law’ say?” but “What does the Scripture say?” These points do not make it impossible that Paul refers here to the testifying role of the law—but they make it unlikely."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.254.41",
      "id": "FN.254.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('p', [_vm._v("(2) According to a second interpretation, the law is established in its role of condemning sinners and preparing the way for Christ."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.254.42",
      "id": "FN.254.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" This function of the law is also mentioned in the context (3:19) and receives extensive treatment in Gal. 3:15–4:7. While this view deserves more consideration than it has been given, it has against it the fact that “law” is not used with this reference in the immediately preceding verses. Yet it is these verses, 27–30, that spark the objection in v. 31.")]), _vm._v(" "), _c('p', [_vm._v("(3) When the meaning of “law” in the immediate paragraph is considered, it is clear that it is the commanding aspect of the law that is prominent: “[law] of works” (v. 27); “works of the law” (v. 28). In fact, as we have noted, Paul normally uses “law” to denote the body of commands given by God through Moses."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.254.43",
      "id": "FN.254.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" And in other contexts where the continuing validity of the law is discussed, this is also the significance of “law” (cf. 7:7–12; 8:2–4; 13:8–10). This makes it likely that Paul argues here for the establishment of the Mosaic law in its commanding aspect. But in what sense is the law as demand established? (a) Does Paul mean that Christians are obliged to continue to obey the (“moral”) demands of the law?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.254.44",
      "id": "FN.254.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" (b) Or does he anticipate 13:8–10, where the command to love is set forth as the “fulfillment” of the law?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.254.45",
      "id": "FN.254.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" (c) Or is he thinking of the way in which our faith in Christ provides for the full satisfaction of the demands of the law "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.255"
    }
  }), _vm._v("(cf. 8:4)?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.255.46",
      "id": "FN.255.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" The brevity of Paul’s assertion and the lack of any immediate explanation make a decision difficult. But the stress on "), _c('i', [_vm._v("faith")]), _vm._v(" as establishing the law suggests that it is law as fulfilled in and through our faith in Christ that Paul thinks of here. In 8:4, Paul will argue that those who are in Christ and who “walk according to the Spirit” have the law fulfilled “in them,” in the sense that their relationship to Christ by faith fully meets the demands of God’s law. While we cannot be certain, it is likely that Paul means essentially the same thing here: that Christian faith, far from shunting aside the demands of the law, provides (and for the first time!) the complete fulfillment of God’s demand in his law.")]), _vm._v(" "), _c('p', {
    staticClass: "dh",
    attrs: {
      "id": "BODY4.1.2.2"
    }
  }, [_vm._v("b. “By Faith Alone”: Elaboration with Respect to Abraham (4:1–25)")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In this chapter, Paul appeals to Abraham to support his insistence that righteousness can be attained only through faith. But, as in 3:27–31, Paul’s purpose is not only to establish the doctrine of justification by faith alone, but also, indeed especially, to draw out the implications of this "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("sola fide.")]), _vm._v(" To accomplish these purposes, Paul “exposits” Gen. 15:6: “Abraham believed God, and it was reckoned to him as righteousness.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.255.1",
      "id": "FN.255.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" This text is quoted in v. 3 after Paul sets up his problem in terms of Abraham’s “right” to boast (vv. 1–2). Thereafter, Paul quotes or alludes to this text in every paragraph of the chapter, using a series of antitheses to draw out its meaning and implications. In vv. 3–8, Paul shows that the “reckoning” of Abraham’s faith for righteousness is an entirely gracious act that by its nature excludes any appeal to works. The contrast between circumcision "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.256"
    }
  }), _vm._v("and uncircumsion dominates vv. 9–12. Here Paul shows that the “reckoning” of Abraham’s faith for righteousness took place before he was circumcised, thereby enabling him to become the “father” of both Jewish and Gentile believers. This same concern with the inclusive importance of Abraham is stressed in vv. 13–22, where Paul focuses on the promise that Abraham would be the father of “many nations,” or “all the seed.” The ruling contrast—though not so clearly sustained as those in the previous two paragraphs—is between “faith” and “law,” with a minor contrast perhaps suggested in vv. 18–21 between faith and “sight.” The quotation of Gen. 15:6 at the end of v. 22 brings Paul’s exposition back to where it began in v. 3; the final three verses of the chapter apply the lessons Paul has drawn from his text to his Christian readers."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.256.2",
      "id": "FN.256.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', [_vm._v("As we noted in the introduction to 3:27–4:25, the parallels between them show that Paul in chap. 4 expands on the themes he introduced in 3:27–31. But why has Paul singled out Abraham as the reference point for this expansion? One reason is undoubtedly polemical. Abraham was revered by the Jews as their “father”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.256.3",
      "id": "FN.256.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" and his life and character were held up as models of God’s ways with his people and of true piety. “Abraham was perfect in all his deeds with the Lord, and well-pleasing in righteousness all the days of his life” ("), _c('i', [_vm._v("Jub.")]), _vm._v(" 23:10); Abraham “did not sin against thee” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.PR.MAN"
    }
  }, [_vm._v("Pr. Man.")]), _vm._v(" 8); “no one has been found like him in glory” (Sir. 44:19)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.256.4",
      "id": "FN.256.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" In keeping with the nomistic focus of first-century Judaism, Abraham was held up particularly as a model of obedience to God. His righteousness and mediation of the promise were linked to this obedience, it even being argued that he had obeyed the law perfectly before it had been given."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.256.5",
      "id": "FN.256.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" Paul would naturally want to show his Roman readers that this understanding of Abraham, which his Jewish and Jewish-Christian opponents undoubtedly cited against his teaching (cf. Gal. 3–4), was not in accord with the OT. Through Paul’s interpretation of Gen. 15:6, Abraham is wrested from the Jews as an exemplar of torah-obedience and made into an exemplar of faith. As a result, Abraham ceases to be for Paul the father of Jews exclusively but the father of all who believe. Käsemann’s judgment is therefore justified: “The polemic which runs through the whole chapter shows that we are dealing here not with an extension or modification of the Jewish view, but with its contrast.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.256.6",
      "id": "FN.256.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.257"
    }
  }), _vm._v("But Paul is drawn to Abraham for more than polemical considerations. That Paul cites Abraham as an example for believers is clear. But Abraham is much more than an example. After all, the Jews focused as much as they did on Abraham because of the decisive role the OT gives to him in the formation of the people of Israel and in the transmission of the promise. Both Paul’s insistence that justification is by faith alone and his concern for the full inclusion of the Gentiles in the people of God make it necessary for him to integrate Abraham theologically into his scheme."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.257.7",
      "id": "FN.257.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" At least, it was necessary if Paul’s teaching was to have any claim to continuity with the OT. It is also evident that Paul considered this continuity to be essential—not just for polemical reasons, but for the sake of the gospel itself, which is the gospel of "), _c('i', [_vm._v("God")]), _vm._v(" (1:1)—“the God of Abraham, Isaac and Jacob.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.257.8",
      "id": "FN.257.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "eh",
    attrs: {
      "id": "BODY4.1.2.2.1"
    }
  }, [_vm._v("i. Faith and Works (4:1–8)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wll"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("1")]), _vm._v("What then shall we say that Abraham, our forefather according to the flesh, has found?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.257.9",
      "id": "FN.257.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("2")]), _vm._v("For if Abraham was justified by works, he has "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.258"
    }
  }), _vm._v("reason to boast, but not before God. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("3")]), _vm._v("For what does the Scripture say? “Abraham believed in God, and it was reckoned to him as righteousness.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.10.A",
      "id": "FN.10.Ar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("4")]), _vm._v("Now for the one who works, the wages are not reckoned according to grace, but according to obligation. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("5")]), _vm._v("But to the one who does not work but believes on the one who justifies the ungodly, his faith is reckoned for righteousness. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("6")]), _vm._v("Just as also David pronounces a blessing on the person to whom God reckons righteousness apart from works:")]), _vm._v(" "), _c('p', {
    staticClass: "wl1"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("7")]), _vm._v("Blessed are those whose lawless acts are forgiven")]), _vm._v(" "), _c('p', {
    staticClass: "wl1"
  }, [_vm._v("and whose sins are covered;")]), _vm._v(" "), _c('p', {
    staticClass: "wl1"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("8")]), _vm._v("blessed is the person whose sin the Lord does not reckon."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.11.B",
      "id": "FN.11.Br",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The argument of the paragraph unfolds in four stages. In vv. 1–2 Paul denies that Abraham is any exception to the principle laid down in 3:27–28: all boasting is excluded because justification is by faith. Verse 3 cites the scriptural evidence for Abraham’s justification by faith. This reckoning of Abraham’s faith for righteousness is shown in vv. 4–5 to be a gracious act of the “God who justifies the ungodly,” thereby eliminating any place for “works” in the process. Finally, vv. 6–8 confirm the sovereign character of God’s “reckoning,” here defined in terms of forgiveness, with appeal to "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.259"
    }
  }), _vm._v("David’s words in Ps. 32:1–2. Verses 4–5, which appeal to the gracious nature of God’s dealings with his people as support for justification by faith apart from works, are the heart of this paragraph. In this sense, we may characterize 4:1–8 as a kind of “commentary” on 3:27–28."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.259.10",
      "id": "FN.259.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿10")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("1")]), _vm._v(" As so often in Romans, Paul uses a rhetorical question to introduce the next stage of his argument: “What then"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.259.11",
      "id": "FN.259.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿11")]), _vm._v(" shall we say that Abraham, our forefather"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.259.12",
      "id": "FN.259.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿12")]), _vm._v(" according to the flesh, has found?”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.259.13",
      "id": "FN.259.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" But just how does Paul’s discussion of Abraham in chap. 4 advance his argument? As we saw in the commentary on 3:31, many scholars take this verse as the heading of chap. 4. On this view, Paul in chap. 4 would be explaining what he means by “we establish the law” in 3:31c: we uphold the testimony of the Pentateuch (Gen. 15:6), which also makes clear that a person is justified by faith (cf. 3:28)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.259.14",
      "id": "FN.259.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" However, we have argued that this reading of 3:31c is unlikely. It is better viewed as a quick riposte to the objection raised in v. 31a, and not as a “heading” or introduction to chap. 4. This being the case, the deliberative question in 4:1 will connect the chapter generally with the discussion in 3:27–31."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.259.15",
      "id": "FN.259.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿15")]), _vm._v(" Paul in chap. 4 elaborates through the history of Abraham each of the key points he has made in 3:27–31."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.259.16",
      "id": "FN.259.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿16")])]), _vm._v(" "), _c('p', [_vm._v("“According to the flesh” is attached by some expositors to the verb. Paul would then be asking what Abraham discovered “by his own [fleshly] exertions.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.259.17",
      "id": "FN.259.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" But the stress in the chapter on the expansion of Abraham’s “fatherhood” to include the spiritual paternity of all believers (cf. vv. 12, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.260"
    }
  }), _vm._v("16–18) suggests rather that this phrase limits “our forefather.” This limitation may involve physical as opposed to spiritual generation—“our [the Jews’] forefather ‘according to natural physical generation.’ ”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.260.18",
      "id": "FN.260.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" But something of the usual pejorative sense of the phrase “according to the flesh” is probably to be found here as well: Abraham’s “paternity” in relationship to Paul and other Jewish Christians (“we”)"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.260.19",
      "id": "FN.260.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" is limited not just by physical descent but also by a narrow, “old era” perspective."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.260.20",
      "id": "FN.260.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" For from a “new era” perspective, Abraham is the father of all believers, both Jewish and Gentile (cf. 4:11–12).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("2")]), _vm._v(" In this verse, Paul explains why"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.260.21",
      "id": "FN.260.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿21")]), _vm._v(" he has asked about Abraham’s experience in v. 1."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.260.22",
      "id": "FN.260.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿22")]), _vm._v(" The flow of thought may be paraphrased: “What shall we say about Abraham? "), _c('i', [_vm._v("For")]), _vm._v(" if we say he was justified by works, he has reason to boast, and my claim in 3:27–28 that all boasting is excluded is called into question.” The question about Abraham’s being justified by works is no idle one. As we have seen, the Jewish interpretation of Abraham stressed his works as the essence of his piety and the basis for his extraordinary, exemplary relationship to God. Paul’s conditional sentence assumes the reality of this situation for the sake of argument—“if Abraham was justified by works”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.260.23",
      "id": "FN.260.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v("—and draws out the consequence: he “has reason to boast.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.260.24",
      "id": "FN.260.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" Paul contests the conclusion in a brief rejoinder: “but not before God.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.260.25",
      "id": "FN.260.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" But does this rejoinder limit Abraham’s boasting or reject it altogether? If the former, Paul would be implying that Abraham’s boasting was limited to the sphere of his fellow human beings: before people Abraham has some reason for pride; but “before God” he has no reason to boast."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.260.26",
      "id": "FN.260.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" If Paul were speaking simply about Abraham’s works, this would be a possible interpretation. But Paul is speaking of Abraham’s works in relation to his justification. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.261"
    }
  }), _vm._v("And since Paul rejects any possibility of justification by works (cf. vv. 3–5), it is more likely that Paul rejects Abraham’s claim altogether: "), _c('i', [_vm._v("all")]), _vm._v(" boasting in this context, whether before God or people, must be ruled out. “But not before God,” then, rejects the logic stated in the conditional sentence: when God’s viewpoint is considered, Abraham has no right to boast at all."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.261.27",
      "id": "FN.261.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" The abrupt “but not before God” states in preliminary fashion the conclusion of Paul’s argument, in which the protasis of the sentence (“if Abraham was justified by works”) is disproved."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.261.28",
      "id": "FN.261.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("3")]), _vm._v(" Paul now explains"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.261.29",
      "id": "FN.261.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿29")]), _vm._v(" this “but not before God” by citing the scriptural teaching about Abraham’s justification. The text that he cites, and which becomes the reference point for the rest of the chapter, is Gen. 15:6."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.261.30",
      "id": "FN.261.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿30")]), _vm._v(" While Jewish authors had already seized on Gen. 15:6 as a particularly important text,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.261.31",
      "id": "FN.261.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(" Paul has more than a polemical purpose in citing the verse. Not only is this the first time the word “believe”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.261.32",
      "id": "FN.261.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(" occurs in Scripture, but it is connected with the attaining of righteousness—one of the very few times in the OT that this connection is made. And the verse, of course, describes Abraham—the “father” of Israel and recipient of God’s promise. Paul therefore has very good reasons from within the OT itself to make this a banner verse for his gospel, as he does both here and in Gal. 3.")]), _vm._v(" "), _c('p', [_vm._v("In Gen. 15:6, Abraham’s “faith” is his complete trust in God with reference to God’s promise that he would have a natural descendant (vv. 4–5). But since this promise is a renewal of the one that God made to Abraham in Gen. 12:1–3, the promise with reference to which Abraham believes in Yahweh "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.262"
    }
  }), _vm._v("includes the worldwide blessing promised in the earlier text."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.262.33",
      "id": "FN.262.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(" Of considerable importance for Paul’s use of the text is the meaning of God’s “reckoning” Abraham’s faith “for” righteousness. The language could suggest that his faith is considered as the “equivalent” of righteousness—that God sees Abraham’s faith as itself a “righteous” act, well pleasing to him."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.262.34",
      "id": "FN.262.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" But if we compare other verses in which the same grammatical construction as is used in Gen. 15:6 occurs, we arrive at a different conclusion. These parallels suggest that the “reckoning” of Abraham’s faith as righteousness means “to account to him a righteousness that does not inherently belong to him.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.262.35",
      "id": "FN.262.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" Abraham’s response to God’s promise leads God to “reckon” to him a “status” of righteousness. If this interpretation of Gen. 15:6 is correct, then Paul’s application of the verse is both fair and appropriate. To be sure, the new connotations given the terms “faith” and “righteousness” as a result of Paul’s christological focus cannot be ignored. But the essential point, that Abraham’s relationship with God is established as an act of God’s grace in response to Abraham’s faith, is the same in both Genesis and Romans."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.262.36",
      "id": "FN.262.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(" Here Paul distances himself emphatically from the typical interpretation. For Jewish interpreters often viewed Gen. 15:6 through the lens of Gen. 22, so that Abraham’s “faith” became his obedience to God and was regarded as a “work” for which God owed Abraham a reward."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.262.37",
      "id": "FN.262.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" Paul’s interpretation stands squarely against this tradition and is also a more faithful interpretation of the original.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.263"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_vm._v("4")]), _vm._v(" In vv. 4–5, Paul draws two theological consequences from what is said about Abraham’s justification in Gen. 15:6: (1) works have no part in justification; and (2) this is so because God’s justifying verdict is not earned, but given freely. To be sure, Paul does not state things in just this way. His argument is more involved and even somewhat unclear. This is because he disrupts what would seem to be an intended parallelism between vv. 4 and 5 by shifting from the contrast between grace and obligation in v. 4 to a conclusion about justification in v. 5. Nevertheless, the two points isolated above emerge clearly enough.")]), _vm._v(" "), _c('p', [_vm._v("The theological application of Gen. 15:6 that Paul makes in vv. 4–5 reveals his true interest in Abraham’s justification and illustrates the hermeneutical principle he states in vv. 23–24: “the words ‘it was reckoned to him’ were written not for his sake alone, but for ours also.” And it is particularly the nature of the “reckoning” that Paul is interested in. Verse 4 picks up this key word"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.263.38",
      "id": "FN.263.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿38")]), _vm._v(" from the quotation in v. 3, as Paul lays down a general principle about the “reckoning” or “accounting” of “wages”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.263.39",
      "id": "FN.263.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" to a worker. If a person “works,” says Paul, the pay he or she receives in return is a matter of obligation, or fair compensation; the employer “owes” the worker a certain wage and is not giving it “freely,” or “without compulsion.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.263.40",
      "id": "FN.263.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" This contrast, which is found in secular commercial language"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.263.41",
      "id": "FN.263.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿41")]), _vm._v(" as well as in the religious discussions of Judaism,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.263.42",
      "id": "FN.263.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" is never given its theological application in this context. But the implicit “theo-logic” of Paul is clear: since work means the reward is given by obligation, the reward of righteousness must not be dependent on work—for God is never obliged by his creatures; justification is a gift, freely bestowed, not a wage, justly earned. That God acts toward his creatures graciously—without compulsion or necessity—is one of Paul’s nonnegotiable theological axioms. He uses it here to show that the faith that gained righteousness for Abraham was a faith that excluded works."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.263.43",
      "id": "FN.263.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" For many of us, accustomed by four centuries of Protestant theology to the Pauline “faith vs. works” contrast, this point might appear mundane. But it flew in the face of the dominant Jewish theology of the day, which joined faith and works closely together, resulting in a kind of synergism with respect to salvation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.263.44",
      "id": "FN.263.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" Against this, Paul argues that the “reckoning” of faith "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.264"
    }
  }), _vm._v("for righteousness—in Abraham’s life, or in anyone else’s—is a reckoning that is wholly of grace and must be, then, based on faith. Viewed in this light, Paul’s point does not rest on an alleged Hebrew concept of reckoning;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.264.45",
      "id": "FN.264.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v(" nor is he arguing that grace is the necessary consequence of reckoning,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.264.46",
      "id": "FN.264.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" or of faith."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.264.47",
      "id": "FN.264.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" Grace is not the end point but the beginning of his logic; from the fact of grace comes the conclusion that the faith that justifies must be a faith that is “apart from” all works (cf. 3:28).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("5")]), _vm._v(" The transition from general principle to theological principle explains the contrast between “the one who works” in v. 4 and “the one who does not work” at the beginning of this verse. With this last clause Paul is not “canonizing laziness” (Morris); nor does he mean that a Christian need never produce “good works.” As Calvin rightly emphasizes, Paul is the last theologian who would countenance a complacent Christian, unconcerned with the active putting into practice of one’s faith. Rather, what Paul has in mind, in light of the contrast with “[the one who] believes on the one who justifies the ungodly,” is the person who does not depend on her works for her standing before God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.264.48",
      "id": "FN.264.48r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" “The one who justifies the ungodly”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.264.49",
      "id": "FN.264.49r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" is justly famous as a succinct and bold statement of Paul’s conviction that our standing with God is wholly of God’s free grace. To appreciate the boldness of this characterization, we must set it beside OT condemnations of human judges who “justify” the guilty (Isa. 5:23; Prov. 17:15), and especially with God’s declaration in Exod. 23:7 that “I will not justify the wicked.” What is involved, of course, is a new application of the word “justify.” The OT texts refer to the declaration or recognition of an existing situation. But Paul has in mind a creative act, whereby the believer is freely given a new “status.” What is highlighted by the phrase is the nature of God—loving, freely giving, and incapable of being put under obligation to any human being. It is the person who believes in "), _c('i', [_vm._v("this")]), _vm._v(" God, and who thereby in his belief renounces any claim on God that his good works might exert, whose “faith is reckoned for righteousness.” Likewise, it becomes clear again that faith for Paul is something qualitatively distinct from any human-originated endeavor. "), _c('i', [_vm._v("We")]), _vm._v(" believe, but we can take no credit for it. As Jonathan Edwards puts it, the point of the verse is,")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "bqs"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.265"
    }
  }), _vm._v("… that God, in the act of justification, has no regard to anything in the person justified, as godliness, or any goodness in him; but that immediately before this act, God beholds him only as an ungodly creature; so that godliness in the person to be justified is not so antecedent to his justification as to be the ground of it."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.265.50",
      "id": "FN.265.50r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', [_vm._v("Paul’s purpose in vv. 4–5, then, is to show that the faith that justifies is “faith alone,” faith “apart from works.” And, as Chrysostom remarks, it is significant that this point is made with reference to Abraham:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "bqf"
  }, [_vm._v("For a person who had no works, to be justified by faith was nothing unlikely. But for a person richly adorned with good deeds, not to be made just from these, but from faith, this is the thing to cause wonder, and to set the power of faith in a strong light.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("6")]), _vm._v(" Paul’s concern to exclude “works” from justification surfaces again in this verse: “Just as also David"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.265.51",
      "id": "FN.265.51r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿51")]), _vm._v(" pronounces"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.265.52",
      "id": "FN.265.52r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿52")]), _vm._v(" a blessing"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.265.53",
      "id": "FN.265.53r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿53")]), _vm._v(" on the person"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.265.54",
      "id": "FN.265.54r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿54")]), _vm._v(" to whom God reckons"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.265.55",
      "id": "FN.265.55r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿55")]), _vm._v(" righteousness apart from works.” Paul’s addition of the negative “apart from works” makes it likely that vv. 6–8 confirm vv. 4–5."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.265.56",
      "id": "FN.265.56r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿56")]), _vm._v(" But Paul probably also intends to add a further OT confirmation of his doctrine of justification by faith (v. 3). If so, Paul may be imitating Jewish homiletical practice by adding to his primary proof from the Pentateuch a secondary witness from “the prophets and the writings.”")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.266"
    }
  }), _vm._v("7–8")]), _vm._v(" The words of David are taken from Ps. 32:1–2a."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.266.57",
      "id": "FN.266.57r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")]), _vm._v(" One of the reasons why Paul quotes these verses is the presence in them of the key word “reckon.” The practice of associating verses from the OT on the basis of verbal parallels was a common Jewish exegetical technique."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.266.58",
      "id": "FN.266.58r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")]), _vm._v(" But unlike the extremely artificial connections between verses often established through this method by Jewish exegetes, Paul’s association of Ps. 32:1–2 with Gen. 15:6 and his exposition of it is very much to the point. For the Psalm verses closely associate the forgiveness of sins (v. 1) with the Lord’s “not reckoning” a person’s sins against her (v. 2). In other words, it is not the “reckoning” of people’s good works but God’s act in "), _c('i', [_vm._v("not")]), _vm._v(" reckoning their sins against them that constitutes forgiveness. This perfectly accords with Paul’s concern to portray justification as a free act of God that has no basis in a person’s works. Two other implications follow from the association of these Psalm verses with Paul’s exposition. First, it is clear that the forgiveness of sins is a basic component of justification. Second, Paul reveals again his strongly forensic understanding of justification. For he uses this quotation to compare justification to the non-accrediting or not “imputing” of sins to a person. This is an act that has nothing to do with moral transformation, but “changes” people only in the sense that their relationship to God is changed—they are “acquitted” rather than condemned.")]), _vm._v(" "), _c('p', {
    staticClass: "eh",
    attrs: {
      "id": "BODY4.1.2.2.2"
    }
  }, [_vm._v("ii. Faith and Circumcision (4:9–12)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("9")]), _vm._v("Therefore, was this blessing given to the circumcised, or to the uncircumcised also? For we are saying, “Faith was reckoned to Abraham for righteousness.” "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("10")]), _vm._v("How, then, was it reckoned? When he was circumcised or when he was yet uncircumcised? It was not when he was circumcised but when he was uncircumcised. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("11")]), _vm._v("And he received circumcision as a sign, a seal of the righteousness of faith that was his when he was uncircumcised, in order that he might be the father of all those who believe while not circumcised—so that righteousness might also"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.266.1",
      "id": "FN.266.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿1")]), _vm._v(" be reckoned to them—"), _c('span', {
    staticClass: "ver"
  }, [_vm._v("12")]), _vm._v("and the father of the circumcised"), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.267"
    }
  }), _vm._v("—those who are not only circumcised but also walk in the steps of our father Abraham, who believed while still uncircumcised.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Quickly returning to his key text, Paul notes another significant aspect of the reckoning of Abraham’s faith for righteousness—it took place before he was circumcised. This circumstance allows Paul to claim Abraham as the father of "), _c('i', [_vm._v("all")]), _vm._v(" believers, both circumcised and uncircumcised. Paul thereby makes clear that it is not necessary to be Jewish to become a member of the people of God. Faith "), _c('i', [_vm._v("alone—")]), _vm._v("apart from works (4:3–8), apart from circumcision (4:9–12)—is sufficient to gain entrance into Abraham’s spiritual “family.” It becomes evident here that Abraham is much more than an “example” of faith. As the recipient and mediator of the promise, his experience becomes paradigmatic for his spiritual progeny.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("9")]), _vm._v(" Having used Ps. 32:1–2 to confirm and interpret Gen. 15:6, Paul now turns back to Gen. 15:6 to add a further dimension to his application of Ps. 32:1–2. The question that is raised is whether “the blessing” of forgiveness of sins, accomplished through the Lord’s gracious “non-reckoning” of them against a person (cf. vv. 7–8), is applicable only “to"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.267.2",
      "id": "FN.267.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿2")]), _vm._v(" the circumcised,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.267.3",
      "id": "FN.267.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" or to the uncircumcised also.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.267.4",
      "id": "FN.267.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" The second sentence of the verse, in which Paul cites Gen. 15:6 again, does not explain the opening question,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.267.5",
      "id": "FN.267.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" nor does it gives its answer."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.267.6",
      "id": "FN.267.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" Rather, Paul here sets the stage for his answer by reminding his readers"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.267.7",
      "id": "FN.267.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿7")]), _vm._v(" of the OT text that speaks authoritatively about these matters."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.267.8",
      "id": "FN.267.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("10")]), _vm._v(" As in vv. 3–5, Paul focuses on the meaning and circumstances of the “reckoning” of Abraham’s faith: “How, then, was it reckoned? When he "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.268"
    }
  }), _vm._v("was"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.268.9",
      "id": "FN.268.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿9")]), _vm._v(" circumcised"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.268.10",
      "id": "FN.268.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿10")]), _vm._v(" or when he was yet uncircumcised?” Paul’s answer is clear and direct: “It was not when he was circumcised but when he was uncircumcised.” Paul does not justify this answer, but the course of the argument in v. 11 makes clear that Paul has in mind the chronological progression of the Genesis narrative about Abraham. Abraham’s faith “is reckoned for righteousness” when God promised him a son (Gen. 15); but it is not until much later—twenty-nine years, according to the rabbis—that he is circumcised (Gen. 17)")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("11")]), _vm._v(" In the first part of this verse, Paul amplifies his answer at the end of v. 10 by showing the relationship between Abraham’s justification by faith and his later circumcision."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.268.11",
      "id": "FN.268.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" What was the significance of Abraham’s circumcision? It was, Paul claims, a “sign.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.268.12",
      "id": "FN.268.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" Paul tells us what this “sign” was in an appositive addition: “a seal of the righteousness of faith that was his"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.268.13",
      "id": "FN.268.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿13")]), _vm._v(" when he was uncircumcised.” Genesis 17:11 calls circumcision a “sign of the covenant.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.268.14",
      "id": "FN.268.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" In light of the tendency among Paul’s Jewish contemporaries to identify this covenant as the Mosaic covenant, Paul’s decision to connect the signatory value of circumcision with “the righteousness of faith” (Gen. 15:6) is emphatic."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.268.15",
      "id": "FN.268.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" Everything in Abraham’s experience with the Lord, Paul suggests, has its source in his justification by faith. While there are Jewish texts that characterize circumcision as a “seal,” their late date makes it uncertain whether the description "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.269"
    }
  }), _vm._v("was known in Paul’s day."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.269.16",
      "id": "FN.269.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" In any case, Paul uses the word to denote something that “confirms” the truth or reality of something else, as in 1 Cor. 9:2, where Paul describes the Corinthian believers themselves as the “seal,” the confirmation and authentication, of his apostleship. In like manner, Abraham’s circumcision confirms his righteous status, a status that was his by virtue of his faith."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.269.17",
      "id": "FN.269.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" Circumcision, therefore, has no independent value. It cannot effect one’s entrance into the people of God; nor does it even “mark” a person as belonging to God’s people apart from a prior justifying act. Abraham was declared righteous while still uncircumcised. His later circumcision added nothing materially to that transaction; it simply signified and confirmed it."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.269.18",
      "id": "FN.269.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', [_vm._v("In verses 11b–12 we have one long purpose clause, with a result clause (“so that righteousness might also be reckoned to them”) stuck inside it. In the major purpose clause, Paul depicts Abraham as the spiritual father of all believers, both Gentiles and Jews. It is dependent on v. 11a, although the two parts of the clause relate to different elements in 11a: because Abraham believed while uncircumcised, he is the father of all Gentile believers; because he believed and was "), _c('i', [_vm._v("also")]), _vm._v(" circumcised, he is qualified to be the father of all Jewish believers. As we have seen, Abraham is specially reverenced as the “father” of the Jewish nation (cf. 4:1); and with salvation practically confined to Israel, this meant that one could become Abraham’s spiritual descendant only through incorporation into Israel—through birth, or, occasionally, through conversion."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.269.19",
      "id": "FN.269.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" Paul now claims Abraham and the inheritance that is "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.270"
    }
  }), _vm._v("his (cf. vv. 16–17), for anyone who believes. It is through faith, and not through incorporation into the nation of Israel, that one becomes Abraham’s spiritual “child.” Indeed, Abraham’s Gentile “children” are mentioned first in the compound purpose clause. Paul at this point inserts a parenthetical remark in which he notes a consequence"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.270.20",
      "id": "FN.270.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿20")]), _vm._v(" of the belief of the Gentiles; they, like Abraham, have their faith reckoned to them for righteousness.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("12")]), _vm._v(" After the brief interruption at the end of v. 11, Paul now resumes his main purpose clause. Paul indicates that Abraham’s receiving of circumcision had the purpose of qualifying him to be the “father of the circumcised—those who are not only circumcised but also walk in the steps of our father Abraham, who believed while still uncircumcised.” But who comprises this category of “the circumcision”? A few expositors think the word might have a spiritual sense here, designating the Christian community as a whole (cf. Phil. 3:3)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.270.21",
      "id": "FN.270.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" But the context of Rom. 4 focuses too much on the distinction between Jews and Gentiles to make that likely. Others think that the long explanatory clause Paul adds to the word “circumcision” makes it clear that he has two groups in mind: both Jewish believers, “children” of Abraham as participants in the righteousness of faith, and Jews generally, who continue to be the beneficiaries of at least some of the promises God made to Abraham (see Rom. 9:5 and 11:28). Advocates of this view argue that the wording of the qualifying clause could point to a translation in which two separate groups are denoted: “not only to those who are ‘of the circumcision’ but also to those who follow in the footsteps of faith that our father Abraham had when uncircumcised.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.270.22",
      "id": "FN.270.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" But there are other elements of the wording that point to one group; and the context strongly suggests that Paul is referring to Jewish Christians: those of the circumcision “who"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.270.23",
      "id": "FN.270.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿23")]), _vm._v(" are not only circumcised but also walk in the steps of our father Abraham,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.270.24",
      "id": "FN.270.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" who believed while still uncircumcised.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.270.25",
      "id": "FN.270.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.271"
    }
  }), _vm._v("In addition to Gentiles who believe, Abraham’s children are also comprised of Jews who believe. In keeping with the theme of the paragraph, Paul stresses again that the faith of Abraham that Jewish Christians imitate is a faith that was first exercised when Abraham was in an “uncircumcised state.” Jews who follow their biblical paradigm will place the proper value on their circumcision: as a mark of a relationship they enjoy with the Lord through their faith rather than as a visa that will automatically insure their entrance into heaven.")]), _vm._v(" "), _c('p', {
    staticClass: "eh",
    attrs: {
      "id": "BODY4.1.2.2.3"
    }
  }, [_vm._v("iii. Faith, Promise, and the Law (4:13–22)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("13")]), _vm._v("For it was not through the law that the promise was to Abraham or to his seed, that they should be the heirs of the world, but through the righteousness of faith. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("14")]), _vm._v("For if those who are of the law were heirs, faith would be emptied and the promise would be nullified. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("15")]), _vm._v("For the law produces wrath. And"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.271.1",
      "id": "FN.271.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿1")]), _vm._v(" where there is no law, neither is there transgression.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("16")]), _vm._v("Because of this, it is of faith, in order that it might be according to grace, so that the promise might be confirmed to all the seed, not to those who are of the law only, but also to those who are of the faith of Abraham, who is the father of us all. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("17")]), _vm._v("Even as it is written, “I have appointed you as the father of many nations,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.12.A",
      "id": "FN.12.Ar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a")]), _vm._v(" before the God in whom he believed, the God who gives life to the dead and calls those things that are not as though they were. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("18")]), _vm._v("Who against hope, on the basis of hope, believed, so that he became the father of many nations, according to what was said, “So shall your seed be.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.13.B",
      "id": "FN.13.Br",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b")]), _vm._v(" "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("19")]), _vm._v("And he did not weaken in faith when he observed"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.271.2",
      "id": "FN.271.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿2")]), _vm._v(" his own body, already"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.271.3",
      "id": "FN.271.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿3")]), _vm._v(" dead—being about "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.272"
    }
  }), _vm._v("a hundred years old—and the deadness of the mother Sarah. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("20")]), _vm._v("He did not doubt the promise of God because of unbelief, but grew strong in faith, giving glory to God, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("21")]), _vm._v("and being fully convinced that he was able also to do what had been promised. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("22")]), _vm._v("Wherefore also"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.272.4",
      "id": "FN.272.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿4")]), _vm._v(" “it was reckoned to him for righteousness.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.14.C",
      "id": "FN.14.Cr",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Many expositors divide this passage into two paragraphs, putting a break after v. 16 or v. 17. But while Paul’s focus does shift at this point from a polemical contrast between law and faith to a more positive portrayal of Abraham’s faith, the theme of the promise runs throughout vv. 13–22, binding them together in an overall unity."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.272.5",
      "id": "FN.272.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" The noun “promise,” which occurs for the first time here in the letter,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.272.6",
      "id": "FN.272.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" is used four times in these verses, the verb “to promise” once. In each case, the reference is to the promise given to Abraham, with Paul emphasizing particularly how it was faith that secured what God had promised. There is evidence that Paul has built his exposition on the foundation of a traditional Jewish and Jewish-Christian interpretation of Abraham’s faith. This interpretation, whose general outline can be discerned in Philo, Acts 7, Heb. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.273"
    }
  }), _vm._v("11, and "), _c('i', [_vm._v("1 Clem.")]), _vm._v(" 10, focuses particularly on the miracle-working power of God and the way Abraham (and Sarah) experienced this power by ignoring the “facts” of the situation and trusting rather in the promise of God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.273.7",
      "id": "FN.273.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" However, while this theme is evident in vv. 17–21, the first part of Paul’s exposition departs from the traditional interpretation with its polemical contrast between the law and faith and, to a lesser extent, with its inclusion of the Gentiles in the “seed” of Abraham. Paul’s concern to claim Abraham as the spiritual ancestor of Christians is evident here again. Surfacing again also is his concern with grace and universalism, which Paul believes can be upheld only if faith rather than the law is the instrument by which what had been promised to Abraham is attained. Verses 13–22 continue, then, Paul’s exposition of faith by way of contrasts: to “faith apart from works” (vv. 3–8) and “faith apart from circumcision” (vv. 9–12), we can add “faith apart from the law” (vv. 13–16) and “faith apart from sight” (vv. 17–21).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("13")]), _vm._v(" As the “for”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.273.8",
      "id": "FN.273.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" suggests, the paragraph beginning in v. 13 has an explanatory function—it explains why Paul made no mention of the law in tracing the spiritual descendants of Abraham (vv. 11–12). This omission, in light of the standard Jewish view that it was Abraham’s fidelity to the law that secured God’s blessing (see the introduction to 4:1–25) and that one could be Abraham’s child only by taking on oneself “the yoke of the torah,” requires explanation and defense. Paul makes his position clear in v. 13: it was not “through law”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.273.9",
      "id": "FN.273.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" but “through the righteousness of faith” “that the promise was to Abraham or to his seed, that they"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.273.10",
      "id": "FN.273.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿10")]), _vm._v(" should be the heirs of the world.” “Law” refers, as the Jewish polemical context makes clear, to the Mosaic law."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.273.11",
      "id": "FN.273.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" In Gal. 3, Paul makes his case for the exclusion of the law from God’s dealings with Abraham on the basis of simple chronology—the law, given four hundred and thirty years after the promise, cannot annul or substantially alter this previous agreement between God and Abraham (vv. 15–17). Some think that his argument is presumed here in Romans also."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.273.12",
      "id": "FN.273.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" But this is not "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.274"
    }
  }), _vm._v("clear. Probably Paul has not used the chronological argument because he wants to apply his reasoning to Abraham’s descendants as well as to Abraham. And, since most of Abraham’s putative descendants lived after the giving of the Mosaic law, the chronological argument would obviously have no point.")]), _vm._v(" "), _c('p', [_vm._v("“Not through the law” denies, then, that what had been promised to Abraham was attained by him or by his descendants through the law, for example, by their doing of the law."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.13",
      "id": "FN.274.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" Rom. 4 does not focus on the christological implications of “seed” that Paul brings out in Gal. 3."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.14",
      "id": "FN.274.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿14")]), _vm._v(" The word here is purely collective, the reference being to all who are numbered among the “descendants” of Abraham (cf. also vv. 16, 18; 9:7–8). The clause “that they should be the heirs of the world” explains what the promise is."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.15",
      "id": "FN.274.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" This language does not exactly match any promise to Abraham found in the OT but succinctly summarizes the three key provisions of the promise as it unfolds in Genesis: that Abraham would have an immense number of descendants, embracing “many nations” (Gen. 12:2; 13:16; 15:5; 17:4–6, 16–20; 22:17), that he would possess “the land” (Gen. 13:15–17; 15:12–21; 17:8), and that he would be the medium of blessing to “all the peoples of the earth” (Gen. 12:3; 18:18; 22:18). Particularly noteworthy is the promise in Gen. 22:17b that Abraham’s seed would “possess"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.16",
      "id": "FN.274.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿16")]), _vm._v(" the gate of their enemies.” Later in the OT, there are indications that the promise of the land had come to embrace the entire world (cf. Isa. 55:3–5),"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.17",
      "id": "FN.274.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" and many Jewish texts speak of Israel’s inheritance in similar terms."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.18",
      "id": "FN.274.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" Against this background—to which we can add Jesus’ beatitude, “Blessed are the gentle, for they shall inherit the earth”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.19",
      "id": "FN.274.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v("—Paul probably refers generally to all that God promised his people."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.20",
      "id": "FN.274.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("14")]), _vm._v(" Paul now explains (“for”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.21",
      "id": "FN.274.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(") why the promise cannot be attained “through the law”: “if"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.22",
      "id": "FN.274.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿22")]), _vm._v(" those who are of the law were heirs,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.274.23",
      "id": "FN.274.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(" faith would be "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.275"
    }
  }), _vm._v("emptied"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.275.24",
      "id": "FN.275.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿24")]), _vm._v(" and the promise would be nullified.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.275.25",
      "id": "FN.275.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" “Those who are out of the law” is a literal and rather awkward translation of a phrase that appears to means something like “those who are basing their hope for the inheritance on the law.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.275.26",
      "id": "FN.275.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" The phrase does not, then, refer to Jews per se,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.275.27",
      "id": "FN.275.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" but to those who have nothing more than their status as Jews as a basis for inheriting the blessings promised to Abraham. For there are Jews who, living “in the sphere of the law,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.275.28",
      "id": "FN.275.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" add to their Jewishness faith in Christ; and the righteousness before God they gain by that faith makes them, like Abraham, heirs of the promise. As “only” is appropriately added to “faith” in 3:28 to bring out the meaning, so also here we might paraphrase “if those who have only the law are heirs.…”")]), _vm._v(" "), _c('p', [_vm._v("Why, if Jews as such were heirs, would faith and the promise be jeopardized? Paul might mean that the granting of the inheritance to Jews on the basis of their relationship to the law would empty the terms “faith” and “promise” of their essential theological meaning. One can hardly apply the word “promise” to something that a person has a “right” to; nor is faith, in the Pauline sense of absolute trust in God, an appropriate word to use for what is one’s “birthright” or “wage.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.275.29",
      "id": "FN.275.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(" However true this may be (cf. 4:4–5), the verbs Paul uses do not naturally suggest this interpretation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.275.30",
      "id": "FN.275.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" In light of these verses, Paul probably means that the exercise of faith has failed to attain its end. Why are faith and the promise rendered futile if Jews apart from faith are the heirs? The reason that is suggested by the logic of Rom. 1–3 and by the explanation in v. 15 is the inherent impossibility of any person adhering to the law to the extent necessary to gain the inheritance. In other words, Paul is arguing: “If it is the case that the inheritance is to be based on adherence to the law, then there will be no heirs, because no fallen human being can adequately adhere to the law—and that means that faith is exercised in vain and the promise will never be fulfilled.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.275.31",
      "id": "FN.275.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.276"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_vm._v("15")]), _vm._v(" The first clause of this verse substantiates the conclusion drawn in v. 14 by showing what the law "), _c('i', [_vm._v("does—")]), _vm._v("“produces"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.276.32",
      "id": "FN.276.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿32")]), _vm._v(" wrath”—as opposed to what it "), _c('i', [_vm._v("cannot do—")]), _vm._v("secure the inheritance. Paul is countering the very positive, and sometimes even salvific, function given the law in Jewish theology. The second clause in the verse is a parenthetical explanation of the reason why the law produces wrath: “And"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.276.33",
      "id": "FN.276.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿33")]), _vm._v(" where there is no law, neither is there transgression.” It is difficult to decide whether the clause is a statement about the Mosaic law specifically or a kind of “gnomic” statement about the nature and function of law, as “law.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.276.34",
      "id": "FN.276.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" In either case, the application is to the Mosaic law, which is clearly referred to in the first part of the verse. But what is the point of this statement? Murray thinks that Paul is justifying the universal infliction of God’s wrath. According to him, Paul’s logic goes like this:")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('p', {
    staticClass: "ul"
  }, [_vm._v("God justly inflicts wrath for transgressions")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("Wherever there is “law,” there is “transgression”")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("“Law” is universal (Paul here assuming what he argued in Rom. 2:12–16)")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("Therefore: God’s infliction of wrath on all people is just")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Another way of reading the clause, however, is to attribute to it the more limited purpose of explaining why the Mosaic law works wrath. Paul’s logic would then be:")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('p', {
    staticClass: "ul"
  }, [_vm._v("Violation of law turns “sin” into the more serious offense of “transgression,” meriting God’s wrath")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("God gave the law to the Jews")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("The Jews have transgressed the law (cf. 2:1–29; 3:9–19)")]), _vm._v(" "), _c('p', {
    staticClass: "ul"
  }, [_vm._v("The law brought wrath to the Jews"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.276.35",
      "id": "FN.276.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿35")])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("This second interpretation is the more likely. A statement about the negative results of the Mosaic law fits well in the context, since vv. 13–16 are dominated by the “not through the law” of v. 13a. An explanation of the causes of God’s "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.277"
    }
  }), _vm._v("wrath does not fit nearly as well and appears to be a needless repetition of the argument of Rom. 1:18–3:20. Moreover, Paul’s use of the word “transgression” rather than “sin” suggests that he is not thinking of the general condition of sin that justifies the infliction of God’s wrath, but the more specific situation that obtains wherever people are confronted with clearly defined, verbally transmitted laws and commands. For Paul does not use “transgression” as a synonym for “sin.” “Transgression” denotes a specific kind of sin, the “passing beyond” the limits set by a definite, positive law or command."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.277.36",
      "id": "FN.277.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(" While every “transgression” is also a “sin,” not every “sin” is a “transgression.” Paul, then, is not claiming that there is no “sin” where there is no law, but, in almost a “truism,” that there is no deliberate disobedience of positive commands where there is no positive command to disobey. As Calvin puts it: “He who is not instructed by the written law, when he sins, is not guilty of so great a transgression as he is who knowingly breaks and transgresses the law of God.” Paul’s real point emerges in the application of this principle to the Mosaic law as an explanation of how it is that “the law works wrath.” Before and outside the Mosaic law wrath certainly exists, for all people, being sinners, stand under God’s sentence of condemnation (1:18). But the Mosaic law “produces” even more wrath; rather than rescuing people from the sentence of condemnation, it confirms their condemnation. For by stating clearly, and in great detail, exactly what God requires of people, the law renders people even more accountable to God than they were without the law."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.277.37",
      "id": "FN.277.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("16")]), _vm._v(" In vv. 14–15 Paul has elaborated the negative point in v. 13: the inheritance comes “not through the law.” Now Paul turns to its positive antithesis: the inheritance is given “through the righteousness of faith.” “Because of this”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.277.38",
      "id": "FN.277.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" may, then, refer back to the negative argument of vv. 14–15: “because of this” incapacity of the law to secure the promise, it must be by faith that it is attained."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.277.39",
      "id": "FN.277.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" However, the phrase “because of this” often looks ahead to a following clause in the NT,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.277.40",
      "id": "FN.277.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" and this makes good sense here. The antecedent of “this” will then be the purpose clause “in order that it might be according to grace.” It is for that reason, that grace might be preserved, that “it is of faith.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.277.41",
      "id": "FN.277.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(" But what is this “it,” the implied subject of the verse? Probably, in light of v. 13, “the promised inheritance.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.277.42",
      "id": "FN.277.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" The intimate relation "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.278"
    }
  }), _vm._v("in Paul’s thought between faith and grace emerges again here. As Paul has shown in vv. 4–5, grace is the necessary corollary to faith, as “obligation” is to works. Thus, “God’s plan was made to rest upon faith on man’s side in order that on God’s side it might be a matter of grace.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.278.43",
      "id": "FN.278.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" But there was, according to Paul, a still further purpose in God’s provision of the inheritance through faith: “that"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.278.44",
      "id": "FN.278.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿44")]), _vm._v(" the promise might be confirmed to all the seed.” The benefit denoted by this clause is, as Chrysostom notes, twofold: that the promise might be “firm”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.278.45",
      "id": "FN.278.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")]), _vm._v("—that it might come to fruition—and that the promise might be confirmed to "), _c('i', [_vm._v("every")]), _vm._v(" descendant of Abraham. Neither blessing would have come to pass if it had depended on human “works” or obedience to the law; but because faith grasps the absolutely sure promise of God, a promise that he has determined freely to give, the inheritance God has promised can become a reality, and a reality for anyone who believes.")]), _vm._v(" "), _c('p', [_vm._v("Paul puts a particular spin on “all the seed” in two contrasting phrases: “not to those"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.278.46",
      "id": "FN.278.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿46")]), _vm._v(" who are of the law only, but also to those who are of the faith of Abraham.” As is the case throughout Romans, and certainly in chap. 4, Paul’s “universalism” is a “qualified” universalism that gives the Gentiles the same opportunity as Jews to respond to the gospel and to become part of the people whom God is calling out of the world in the last days. While Paul does not express himself extremely clearly, this inclusion of both Jew and Gentile in the “seed” of Abraham is what is in view in this last part of v. 16. “Those who are of the law only” could, especially in light of the contrast with “those who are of the faith of Abraham,” refer to unbelieving Jews."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.278.47",
      "id": "FN.278.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" In this case, Paul would be asserting that Jews continue to be part of the “seed of Abraham,” in a different way, however, from that in which Christians are the seed of Abraham. Such a point would not, if properly nuanced, be incompatible with Paul’s thought (see Rom. 11:11–30). But it is perhaps unlikely that this is what he intends here. Paul has forcefully stated that the true descendants of Abraham are those who believe (vv. 11–12); and when he uses the word “seed” here, it must be with this spiritual meaning that he has given the word. Moreover, the phrase “out of faith” rules "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.279"
    }
  }), _vm._v("the entire verse and must be carried over to this latter part of it. The meaning, then, is that the promise is for the Jew who is part of the seed through faith."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.279.48",
      "id": "FN.279.48r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" “Out of the law” must mean something a bit different from what it does in v. 11, and designate Jews as such, “those who had the advantage of being under the Mosaic economy.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.279.49",
      "id": "FN.279.49r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" In light of the contrast indicated by “not only … but also,” “those out of the faith of Abraham” are Gentile believers."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.279.50",
      "id": "FN.279.50r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" It is in this sense that Abraham is the “father of us all”—the spiritual forefather of all of “us” who are believers.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("17")]), _vm._v(" This verse is composed of two main clauses:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "bqf"
  }, [_vm._v("Even as it is written, “I have appointed you as the father of many nations”")]), _vm._v(" "), _c('p', {
    staticClass: "bqs"
  }, [_vm._v("before the God in whom he believed,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.279.51",
      "id": "FN.279.51r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")]), _vm._v(" the one who gives life to the dead and calls those things that are not as though they were.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("They can be related to one another and to the larger context in several ways. (1) The two clauses could follow one another in a straightforward, consecutive sequence, with the quotation from Gen. 17:5 confirming “who is the father of us "), _c('i', [_vm._v("all")]), _vm._v("” at the end of v. 16, and the second clause being dependent on the first clause."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.279.52",
      "id": "FN.279.52r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")]), _vm._v(" (2) The first clause could confirm “to all the seed” in the middle of v. 16, with the second clause again dependent on the first."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.279.53",
      "id": "FN.279.53r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")]), _vm._v(" (3) According to most commentators, v. 17a depends on 16b, as in the first reading, but is somewhat parenthetical, with 17b taken with “father of us all” in v. 16b."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.279.54",
      "id": "FN.279.54r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")]), _vm._v(" (4) Again, as in v. 1, the first clause may be attached to v. 16b, with the second "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.280"
    }
  }), _vm._v("clause going as far back as “all the seed” in v. 16."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.280.55",
      "id": "FN.280.55r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿55")]), _vm._v(" (5) Finally, one could construe the first clause according to any of these suggestions, with the second clause initiating a new paragraph."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.280.56",
      "id": "FN.280.56r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('p', [_vm._v("The connection between “father” in the quotation in v. 17a and “father” in v. 16b is so clear that we must take these clauses closely together, as is done in all the alternatives except the second. There is some truth in the last suggestion, for v. 17b does prepare the way for the exposition of Abraham’s faith, with its application to Christians, in vv. 18–25. But the relative clause also looks backward—it functions as the pivot in Paul’s argument."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.280.57",
      "id": "FN.280.57r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")]), _vm._v(" But to what, exactly, does it look back? This is the most difficult problem, and the one that serves to differentiate the remaining three alternatives (1, 3, and 4). The connection is awkward in any case, because the preposition “before” does not naturally follow on any of the verbs found in the three immediately preceding clauses. But the connection that makes the most sense is with the immediately preceding clause (e.g., option 1). It adds little to Paul’s point to note that the confirmation of the seed (v. 16a) or the spiritual fatherhood of Abraham (v. 16b) exists “in the sight of God,” for, while true, it hardly needs to be said. On the other hand, to add to the quotation of a promise that is couched in the past tense—“I "), _c('i', [_vm._v("have")]), _vm._v(" made you the father of many nations”—a reminder of the nature of this God “in the presence of whom” the promise is given and accepted explains the certainty expressed in that past tense. God can promise Abraham—and Abraham can believe—that certain things not now existing "), _c('i', [_vm._v("will")]), _vm._v(" exist because God is the God who “gives life to the dead and calls those things that are not as though they were.”")]), _vm._v(" "), _c('p', [_vm._v("The quotation in v. 17a, from Gen. 17:5,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.280.58",
      "id": "FN.280.58r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿58")]), _vm._v(" substantiates v. 16, the “many nations” including both Jews and Gentiles. The promise in Genesis probably has a similar intention, although whether it refers simply to physical ancestry or spiritual “fatherhood” also is not clear. Paul’s further characterization of God in terms of his “making alive” and “calling” picks up widespread OT and Jewish teaching. God’s power to give life is underscored in the OT (Deut. 32:39; 1 Sam. 2:6) and was featured in the important Jewish liturgy, the "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Shemoneh Ezreh")]), _vm._v(", the “Eighteen Benedictions.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.280.59",
      "id": "FN.280.59r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")]), _vm._v(" In light of the promise quoted in v. 17a, Paul is thinking to some extent of God’s bringing life from the body of Abraham and the womb of Sarah."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.280.60",
      "id": "FN.280.60r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")]), _vm._v(" The exposition of "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.281"
    }
  }), _vm._v("Abraham’s faith that follows confirms this, as v. 19 notes the “deadness” of Abraham’s body and the barrenness of Sarah as the visible evidence that Abraham’s faith had to transcend. However, this characterization of God receives a further application in the context, vv. 24–25 defining as the object of Christian belief “the one who raised Jesus our Lord from the dead.” Finally, it is possible, though perhaps unlikely, that Paul is also thinking of the application of these words to the rescue of Isaac from his near death (cf. Heb. 11:19).")]), _vm._v(" "), _c('p', [_vm._v("It is more difficult to know what Paul intends by describing God as the one “who calls those things that are not as though they were.” Our conclusion will depend on the meaning we give to “call.” If it means, prosaically, “name” or “address,” then Paul would be further alluding to the certainty of the fulfillment of God’s promise to Abraham: although “the many nations” do not yet exist, God can address them as if they did."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.281.61",
      "id": "FN.281.61r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")]), _vm._v(" Somewhat similar is the interpretation that takes “call” to mean “summon”: God summons, calls up before Abraham’s view, these nations that “are not” as if they were."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.281.62",
      "id": "FN.281.62r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")]), _vm._v(" While each of these explanations fits the syntax and the context well, some interpreters discern a further reference. In the OT, the verb “call” refers to God’s creative work (cf. Isa. 41:4; 48:13), and later Jewish authors perpetuate this usage, sometimes adding the idea that this creative “calling” involves a bringing into being things that were not."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.281.63",
      "id": "FN.281.63r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")]), _vm._v(" It may be, then, this tradition of a "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("creatio ex nihilo")]), _vm._v(" to which Paul alludes, with the purpose of reminding his readers of God’s creative power generally."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.281.64",
      "id": "FN.281.64r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")]), _vm._v(" Moreover, several texts apply this language to spiritual conversion, and sometimes, as here, with reference to God’s giving life to the dead."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.281.65",
      "id": "FN.281.65r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")]), _vm._v(" These parallels make it possible that Paul’s description of God as “the one who calls into being things that are not” is a reminder that God “justifies the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.282"
    }
  }), _vm._v("ungodly” (v. 5): he creates out of the nothingness of people’s empty, sinful lives a new, vibrant, spiritual life."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.282.66",
      "id": "FN.282.66r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" "), _c('p', [_vm._v("There can be no doubt that Paul’s language is quite close to this Jewish "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("creatio ex nihilo")]), _vm._v(" tradition and that an allusion to either God’s general creative power or his spiritual creative power would not be out of place in the context. However, if this were Paul’s purpose, it is surprising that he speaks of God’s calling things “as though” they existed; we would have expected him to say “calls things into being.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.282.67",
      "id": "FN.282.67r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")]), _vm._v(" This leads us to conclude, somewhat hesitantly and reluctantly, that the clause cannot refer to God’s creative power as such, whether general or spiritual. It is, then, the nature of God as “speaking of” or “summoning” that which does not yet exist as if it does that Paul must mean. And this interpretation fits the "), _c('i', [_vm._v("immediate")]), _vm._v(" context better than a reference to God’s creative power, for it explains the assurance with which God can speak of the “many nations” that will be descended from Abraham.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("18")]), _vm._v(" As we have seen, a number of commentators hold that a new paragraph begins here."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.282.68",
      "id": "FN.282.68r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")]), _vm._v(" However, while it is true that Paul shifts his focus a bit, spotlighting the positive characteristics of Abraham’s faith in vv. 18–21, his attention is still on the promise: how Abraham responded to the promise—in faith—and how it was "), _c('i', [_vm._v("that")]), _vm._v(" faith which secured righteousness and what had been promised. The emphasis in v. 18 falls on the paradoxical description of Abraham’s faith as “against hope, on the basis of hope.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.282.69",
      "id": "FN.282.69r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")]), _vm._v(" No better explanation of the phrase can be found than Chrysostom’s: “It was against man’s hope, in hope which is of God.” As Paul will explain in v. 19, Abraham had every reason, from a human point of view, to give up the attempt to produce a child through Sarah. His faith flew in the face of that hope which is founded on the evidence of reason and common sense—“hope” as we often use the word (“I hope to win the lottery”). Yet his faith was firmly based on the hope that springs from the promise of God. We note here that Abraham’s faith is not described as a “leap into the dark,” a completely baseless, almost irrational “decision”—as Christian faith is pictured by some "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.283"
    }
  }), _vm._v("“existentialist” theologians—but as a “leap” from the evidence of his senses into the security of God’s word and promise.")]), _vm._v(" "), _c('p', [_vm._v("As a consequence of his strong faith, Abraham “became the father of many nations.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.283.70",
      "id": "FN.283.70r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")]), _vm._v(" Paul indicates that Abraham’s clinging in faith to the divine promise resulted in the fulfillment of what he had been promised. Instead of Gen. 17:5, Paul quotes an earlier promise to Abraham, from Gen. 15:5. After inviting Abraham to contemplate the star-strewn desert sky, God promises him: “Thus shall your descendants be.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.283.71",
      "id": "FN.283.71r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")]), _vm._v(" This suggests that, in Paul’s mind, the “many nations” of which Abraham is the father are equivalent to the spiritual “seed” made up of believing Jews and Gentiles (see v. 16).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("19")]), _vm._v(" Verses 19–20 detail the way in which Abraham believed “against hope on the basis of hope.” Almost all commentators make “weakening” subordinate to “observed,” the normal relationship between a participle and finite verb. But Greek does allow for a reversal of these roles, with the finite verb expressing the subordinate thought, and this makes good sense in the present verse: “He did not weaken in faith"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.283.72",
      "id": "FN.283.72r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿72")]), _vm._v(" when he observed his own body.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.283.73",
      "id": "FN.283.73r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")]), _vm._v(" The “against hope” aspect of Abraham’s faith is accentuated, as Paul stresses that Abraham continued to believe God’s promise to him even as he observed the physical condition that rendered the fulfillment of that promise so unlikely.")]), _vm._v(" "), _c('p', [_vm._v("This physical evidence would certainly have given Abraham reason to doubt that he would produce offspring through Sarah. His own body was “already dead,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.283.74",
      "id": "FN.283.74r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")]), _vm._v(" in the sense that he was past the age when procreation was likely to occur—he was “about a hundred years old” (cf. also Heb. 11:12)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.283.75",
      "id": "FN.283.75r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.284"
    }
  }), _vm._v("Since Gen. 17:1 claims that Abraham was ninety-nine years old when the promise of offspring was renewed, Paul’s is an acceptable approximation. But standing in the way of the fulfillment of the promise was not only Abraham’s advanced age but the “deadness,” the “barrenness,” of Sarah, the woman predicted to be the mother of the child through whom Abraham’s “seed” would come. Since the word “deadness”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.284.76",
      "id": "FN.284.76r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")]), _vm._v(" is not the normal word for a woman’s barrenness, Paul has deliberately chosen his language to make clear that Abraham’s faith with respect to this promise was specifically faith in the “God who gives life to the dead” (v. 17b). In another way, also, our faith is to be like Abraham’s, as Calvin eloquently notes:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "bqf"
  }, [_vm._v("Let us also remember, that the condition of us all is the same with that of Abraham. All things around us are in opposition to the promises of God: He promises immortality; we are surrounded with mortality and corruption: he declares that he counts us just; we are covered with sins: He testifies that he is propitious and kind to us; outward judgments threaten his wrath. What then is to be done? We must with closed eyes pass by ourselves and all things connected with us, that nothing may hinder or prevent us from believing that God is true.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("20")]), _vm._v(" This verse resumes and expands on what we have identified as the main point of v. 19: “[Abraham] did not weaken when he considered.…”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.284.77",
      "id": "FN.284.77r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")]), _vm._v(" The Greek phrase equivalent to “the promise of God”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.284.78",
      "id": "FN.284.78r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")]), _vm._v(" comes first in the sentence for emphasis. When Paul says that Abraham did not “doubt … because of unbelief,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.284.79",
      "id": "FN.284.79r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")]), _vm._v(" he means not that Abraham never had "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.285"
    }
  }), _vm._v("momentary hesitations, but that he avoided a deep-seated and permanent attitude of distrust and inconsistency in relationship to God and his promises."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.285.80",
      "id": "FN.285.80r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")]), _vm._v(" Unlike the “double-souled” person who displays a deeply rooted division in his attitude toward God (Jas. 1:6–8), Abraham maintained a single-minded trust in the fulfillment of God’s promise."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.285.81",
      "id": "FN.285.81r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" "), _c('p', [_vm._v("In contrast to"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.285.82",
      "id": "FN.285.82r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿82")]), _vm._v(" Abraham’s refusal to waver in disbelief, he “grew strong"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.285.83",
      "id": "FN.285.83r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿83")]), _vm._v(" in faith.” This phrase might refer to the procreative power that Abraham attained through his faith."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.285.84",
      "id": "FN.285.84r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")]), _vm._v(" But the natural contrast between “he did not weaken in faith” in v. 19a and this clause makes it probable that “faith” is the object rather than the means or cause of the “strengthening”: it was Abraham’s faith itself that grew stronger."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.285.85",
      "id": "FN.285.85r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")]), _vm._v(" In what way did Abraham’s faith “grow strong”? In the sense that anything gains strength in meeting and overcoming opposition—muscles when weights are raised; holiness when temptation is successfully resisted. So Abraham’s faith gained strength from "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.286"
    }
  }), _vm._v("its victory over the hindrance created by the conflict between God’s promise and the physical evidence. And in this strengthening of his faith, Abraham gave “glory"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.286.86",
      "id": "FN.286.86r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿86")]), _vm._v(" to God.” In his faithful response to God’s word, Abraham therefore accomplished what the idolaters of 1:21 failed to do.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("21")]), _vm._v(" The sentence begun in v. 20 is continued. As “giving glory to God” denotes the result of Abraham’s growing strong in faith, “being fully convinced"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.286.87",
      "id": "FN.286.87r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿87")]), _vm._v(" that he was able also to do what had been promised” repeats and further describes what this “growing strong” means. It is Abraham’s conviction that God is fully able to do whatever he promised that enabled his faith to overcome the obstacle of the tangible and visible “facts.”")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("22")]), _vm._v(" “Wherefore”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013#FN.286.88",
      "id": "FN.286.88r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")]), _vm._v(" indicates that this verse draws a consequence or conclusion from the preceding verses. Paul certainly sees this as the conclusion of the immediately preceding verses, in which he has described Abraham’s faith (vv. 18–21). And since these verses include aspects of the promise that are brought out in Gen. 17 and later, it would seem that Paul agrees to this extent with the Jewish tradition, that the faith Abraham exercised in Gen. 15:6 is explained and exemplified in the later career of the patriarch. But the verse may serve to conclude more than the immediate section. With a last reference to Gen. 15:6, Paul rounds off the discussion of that verse which has been the constant touchstone since v. 3. Now, in a sense, Paul’s “historical” exposition is ended, and he can turn in application to his Christian readers.")]), _vm._v(" "), _c('p', {
    staticClass: "eh",
    attrs: {
      "id": "BODY4.1.2.2.4"
    }
  }, [_vm._v("iv. The Faith of Abraham and the Faith of the Christian (4:23–25)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("23")]), _vm._v("And it was not written for him only, that “it was reckoned to him,” "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("24")]), _vm._v("but also for us, to whom it was going to be reckoned, to those who believe in the one who raised Jesus our Lord from the dead, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("25")]), _vm._v("who was handed over because of our trespasses and raised for our justification.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("While these three verses are related to vv. 18–22, they can be considered a separate paragraph because they draw conclusions from the entire exposition of vv. 3–22. Paul has, of course, applied his far-ranging exposition of Gen. 15:6 to Christians throughout the chapter, in both explicit and implicit ways. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.287"
    }
  }), _vm._v("But nowhere does he so solemnly and clearly state the application as he does here.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("23")]), _vm._v(" The conviction expressed in vv. 23–24 that what is written in Genesis about Abraham has relevance to the Christian believer has been the implicit assumption of the whole of chap. 4. There is a close relationship between vv. 23–24 and v. 22: “[It was the faith delineated in vv. 18–21 that] ‘was reckoned’ to Abraham for righteousness (22), but this ‘it was reckoned’ was written not for his sake only (23), but also for ours.…” Paul’s conviction that the OT everywhere speaks to Christians is fundamental to his theology and preaching."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.287.1",
      "id": "FN.287.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" In the interests of avoiding hermeneutical foolishness, however, we must be quite clear in what way various parts and verses of the OT are relevant to the Christian. In the case of Gen. 15:6, the significance is clear and very direct. Christians share with Abraham the same basis for justification—faith—and the same God as the object of that faith. Paul cites only the words “it was reckoned to him” from Gen. 15:6 in v. 23, perhaps as a “shorthand” allusion to the verse, or perhaps because all along it has been Paul’s concern to unfold the meaning of that “reckoning.” It is "), _c('i', [_vm._v("faith")]), _vm._v(" that is “reckoned”: a faith that is "), _c('i', [_vm._v("apart from works, apart from circumcision, apart from the law, apart from sight—")]), _vm._v("and therefore a “reckoning” that is solely a matter of "), _c('i', [_vm._v("grace")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("24")]), _vm._v(" Paul chooses to describe Christians in two parallel clauses,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.287.2",
      "id": "FN.287.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" each of which brings out their connection with Abraham. First, Christians are those “to whom it was going to be"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.287.3",
      "id": "FN.287.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿3")]), _vm._v(" reckoned”: that is, those people who experience in its eschatological fullness the righteousness that Abraham attained by faith. Second, Christians are “those who believe in the one who raised Jesus our Lord from the dead.” It is typical for Paul to designate God as the one who raised Jesus from the dead (cf. 8:11; 10:9; 1 Cor. 6:14; 15:15; 2 Cor. 4:14), but it is somewhat unusual for him to designate God himself as the object of Christian faith. Undoubtedly he does so here to bring Christian faith into the closest possible relationship to Abraham’s faith. Not only is our faith of the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.288"
    }
  }), _vm._v("same nature as Abraham’s; it ultimately has as its object the same God, “who gives life to the dead” (cf. v. 17b). And the connection is even closer. For Abraham’s faith in God had to do not just with the miraculous creation of life where there was “deadness,” but with the fulfillment of God’s promise to bless the world through him. It is the God of the promise, the promise given to Abraham but ultimately fulfilled in Christ and Christians, in whom both Abraham and we believe. While, therefore, the locus of faith has shifted as the course of salvation history has filled out and made ever more clear the specific content of the promise, the ultimate object of faith has always been the same.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("25")]), _vm._v(" The last words of v. 24 have a rather solemn tone, and this is continued in v. 25. The two clauses of the verse exhibit a clear parallelism:")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "80%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("who")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("was handed over")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("because of our trespasses"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.288.4",
      "id": "FN.288.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿4")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("and")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("was raised")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("because of our justification"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.288.5",
      "id": "FN.288.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿5")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Most commentators think that this parallelism betrays the presence of a pre-Pauline tradition."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.288.6",
      "id": "FN.288.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" This may well be the case, although it must be insisted that, if so, Paul has fully integrated the elements of the tradition into his exposition. But, whether traditional or not, the wording resembles that of the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" of Isa. 53, particularly v. 12: “because of their sins he was handed over.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.288.7",
      "id": "FN.288.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" As is probably the case in Isaiah, and certainly in Paul (cf. 8:32), the passive “was handed over” is a “divine passive,” God being the implied agent of the action. God the Father has himself taken the initiative in giving up his Son to and for sinful people (cf. 3:25: “God set forth Christ as a propitiation”).")]), _vm._v(" "), _c('p', [_vm._v("The second line of the formula—“who was raised because of our justification”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.288.8",
      "id": "FN.288.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v("—may allude to Isa. 53 as well, for the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" of v. 11 (which differs widely from the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MT"
    }
  }, [_vm._v("MT")]), _vm._v(") speaks of the servant as “justifying the righteous.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.288.9",
      "id": "FN.288.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.289"
    }
  }), _vm._v("But the allusion is not clear, since the meaning of the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" is not the same as Paul’s. The puzzling feature of the second line is the connection Paul suggests between Jesus’ resurrection and our justification. Paul uses a preposition that normally means “because of”; and if we give it this meaning here, Paul will be suggesting that our justification was in some sense a cause of Jesus’ resurrection. Godet, who argues for this meaning, suggests that Paul is teaching that Christ’s death had definitively effected justification and that his resurrection was therefore the “necessary effect.” Yet it is difficult to see why this would be so, and Paul has hitherto used “justification” with reference to the subjective appropriation through faith. Accordingly, we can give the preposition a “prospective” reference—“because of” in the sense of “because of the need to,” “for the sake of”: Christ was raised “for the sake of” our justification."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.289.10",
      "id": "FN.289.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" The problem with this interpretation is that it is difficult to give this meaning to the same preposition because it is used in the parallel first clause. Some attempt to find this meaning there also by suggesting that we add an inference: “he was handed over for the sake of [for the purpose of] "), _c('i', [_vm._v("taking care of")]), _vm._v(" transgressions.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.289.11",
      "id": "FN.289.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" But since maintaining the same meaning for this preposition in both lines requires questionable additions or interpretations of one line or the other, it is probably best to give the word a retrospective meaning in the first line and a prospective meaning in the second: “he has handed over "), _c('i', [_vm._v("because of")]), _vm._v(" our trespasses [e.g., because we are sinners], and was raised "), _c('i', [_vm._v("for the sake of")]), _vm._v(" our justification [e.g., in order to secure our justification].”")]), _vm._v(" "), _c('p', [_vm._v("Finally, the theological implications of the formula need to be explored. Particularly striking, because unusual, is the connection made between Christ’s resurrection and our justification. To be sure, it would be easy to make too much of this; the division of the lines may be purely for rhetorical effect, the whole formula saying no more than that Jesus’ death and resurrection are basic to the believer’s salvation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.289.12",
      "id": "FN.289.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" There is some truth to this, as is clear from "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.290"
    }
  }), _vm._v("the fact that Paul would obviously not want to separate Christ’s death (the first line) from our justification (the second line). But when due allowance is made for rhetoric, we must still insist that Paul is affirming here a theological connection between Jesus’ resurrection and our justification (cf. 5:10). As Jesus’ death provides the necessary grounds on which God’s justifying action can proceed, so his resurrection, by vindicating Christ and freeing him forever from the influence of sin (cf. 6:10), provides for the ongoing power over sins experienced by the believer in union with Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "BODY5"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rBODY5"
    }
  }, [_vm._v("III. THE ASSURANCE PROVIDED BY THE GOSPEL: THE HOPE OF SALVATION (5:1–8:39)")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In this letter to the Romans, Paul explains and defends his gospel to a Christian community he has neither founded nor visited but which he hopes to enlist as supporters of an evangelistic campaign in the western Mediterranean. To accomplish this purpose, Paul writes a “tractate”-style letter with a careful and logical structure. After introducing himself as one “set aside for the gospel” and announcing his plans to bring that “good news” to Rome (1:1–15), Paul justifies his commitment to the gospel because it transmits “God’s power that brings salvation” (1:16). And why does the gospel have such power? Because, Paul explains, it reveals God’s justifying activity—and all who respond to that activity in faith become “just” before God (1:17). This teaching of “justification by faith,” so basic to Paul’s gospel, is the theme of the first major section of the letter (1:18–4:25). To explain why God has manifested this new justifying activity, and why it can be experienced only by faith, Paul shows that all people have rebelled against God and are helpless under the power of sin, unable of themselves to do anything to escape God’s impartial judgment (1:18–3:20). But, expanding on 1:17, Paul shows how God’s sacrifice of his Son has enabled him both to rescue people from this dilemma and to do it without violating his own holy justice (3:21–26). Again, though, Paul stresses that this new relationship with God is available only for those who believe—it cannot be attained by works, or by circumcision, or by the law (3:27–4:25). But, as these last negations reveal, Paul’s exposition of the gospel has constant reference to Jewish viewpoints. In both major sections of 1:18–4:25, Paul shows how the revelation of God’s righteousness erases distinctions between Jews and Gentiles: the Jew, like the Gentile, is under the power of sin (3:9); the Jew, like the Gentile, can be justified only by faith (3:28–30).")]), _vm._v(" "), _c('p', [_vm._v("How does chap. 5 carry on Paul’s argument? Since Paul continues to stress justification (5:1, 9, 16–19, 21) and only at 6:1 breaks the course of the argument with a rhetorical question about the Christian life, chap. 5 could be "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.291"
    }
  }), _vm._v("closely connected to 1:18–4:25, with chaps. 6–8 forming the second major section of the letter."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.291.1",
      "id": "FN.291.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" This has been a very popular way of outlining the letter, with 1:18–5:21 and 6–8 often being viewed as describing, respectively, “justification” and “sanctification.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.291.2",
      "id": "FN.291.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" Another way of looking at the matter is to place a major transition at the middle of the chapter, with 1:18–5:11 being dominated by the antithesis between sin and justification and 5:12–8:39 by the antithesis between life and death."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.291.3",
      "id": "FN.291.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" Each section would then go over similar ground, with an introductory section on sin (1:18–3:20; 5:12–21) and a concluding section on hope (5:1–11; 8:18–39)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.291.4",
      "id": "FN.291.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" Still others insist that the chapter is transitional and refrain from attaching it more to what precedes or to what follows."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.291.5",
      "id": "FN.291.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" But, as the heading to the section indicates, I think it better to place the transitional point between chaps. 4 and 5. To be sure, this whole question requires caution, lest we impose on the letter a rigidly logical, dogmatically oriented outline that Paul may never have intended. After all, he is writing a letter, not a systematic theology."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.291.6",
      "id": "FN.291.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" Nevertheless, while mindful of the danger of oversystematizing and of erecting barriers between sections so that the continuity of Paul’s argument is lost,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.291.7",
      "id": "FN.291.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" Paul "), _c('i', [_vm._v("is")]), _vm._v(" arguing, and arguing "), _c('i', [_vm._v("theologically;")]), _vm._v(" therefore, it is quite appropriate to look for transitions in that argument. While we must not draw too heavy a line between chaps. 4 and 5, the progress of Paul’s argument reveals a transition in topic at this point."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.291.8",
      "id": "FN.291.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.292"
    }
  }), _vm._v("Four main arguments combine to show that Paul intends a transition in the letter at 5:1. First, the opening phrase of the chapter, “having been justified by faith,” summarizes the argument of 1:18–4:25 while preparing the way for a new topic that will build on it. Second, a shift in style at 5:1 is noticeable. 1:18–4:25 has a polemical tone—Paul is plainly "), _c('i', [_vm._v("arguing")]), _vm._v(" against a (mainly) Jewish viewpoint, sometimes addressing his opponent directly in the second person singular. But with 5:1, the first person plural begins to dominate, Paul including fellow Christians with him in a more “confessional” style: “"), _c('i', [_vm._v("we")]), _vm._v(" have peace,” “access,” “"), _c('i', [_vm._v("we")]), _vm._v(" rejoice,” “Christ died for "), _c('i', [_vm._v("us,")]), _vm._v("” “"), _c('i', [_vm._v("we")]), _vm._v(" are now justified,” “"), _c('i', [_vm._v("we")]), _vm._v(" have now received our reconciliation.” While not as concentrated as in 5:1–11 (from which the quotations are taken), this style recurs throughout chaps. 5–8."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.292.9",
      "id": "FN.292.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿9")]), _vm._v(" A third indication that a shift in focus occurs at 5:1 is the relative frequency of certain key words in chaps. 5–8 in comparison with 1:18–4:25. Particularly striking is the contrast between the 33 occurrences of “faith” and “believe” in 1:18–4:25 and the three uses in chaps. 5–8 (and two of the latter refer back to the argument in 1:18–4:25). On the opposite side, “life” and “to live,” used only twice in the first section, occur 24 times in chaps. 5–8. No such clear contrast is present in “righteousness” words: there are 26 in 1:18–4:25 and 16 in chaps. 5–8. But a closer analysis reveals a significant difference. In the earlier section, the great majority of occurrences focus on justification as the status attained by the sinner through faith, while in chaps. 5–8 the connection with faith is rare, the words denoting the status of justification as the means to eternal life (5:12–21) or having a more “ethical” connotation as a description of the Christian obligation (6:15–23). While statistics are easily used (or abused!) to prove anything anyone wants, these figures concern key words in Paul’s argument and signal a significant shift in focus."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.292.10",
      "id": "FN.292.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', [_vm._v("The fourth, and most important, argument for connecting chap. 5 more closely with what follows than with what precedes is that it provides a more convincing reading of what Paul is teaching in this part of the letter than any "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.293"
    }
  }), _vm._v("alternative is able to give. As several scholars have noticed, key words found in 5:1–11 recur again in 8:18–39. Note the following:")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("5:1–11")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("5:12–8:16")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8:18–39")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bordertop"
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("“love” (of God/Christ)")])]), _vm._v(" "), _c('td', {
    staticClass: "bordertop"
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("5:5, 8")])]), _vm._v(" "), _c('td', {
    staticClass: "bordertop"
  }, [_c('p', {
    staticClass: "tdctr"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', {
    staticClass: "bordertop"
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("8:35, 39")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“justify”")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("5:1, 9")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdctr"
  }, [_vm._v("6:7")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8:30 (twice), 33")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“glory”")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("5:2")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdctr"
  }, [_vm._v("6:4")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8:18, 21, 30 (“glorify”)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“peace”")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("5:1")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdctr"
  }, [_vm._v("8:6")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("—")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“hope”")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("5:2, 4, 5")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdctr"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8:20, 24 (four times), 25")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“tribulation”")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("5:3 (twice)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdctr"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8:35")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“save”")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("5:9, 10")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdctr"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8:24")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("“endurance”")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("5:3, 4")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdctr"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("8:25")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Both 5:1–11 and 8:18–39 affirm, against the threat of tribulation and suffering, the certainty of the Christian’s final salvation because of God’s love, the work of Christ, and the ministry of the Holy Spirit."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.293.11",
      "id": "FN.293.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" This theme, the “hope of sharing in God’s glory” (cf. 5:2 and 8:18, 30), “brackets” all of chaps. 5–8. Assurance of glory is, then, the overarching theme in this second major section of Romans."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.293.12",
      "id": "FN.293.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" The verdict of justification, which Jews relegated to the day of judgment, has, Paul proclaims, already been rendered over the person who believes in Jesus. But can that verdict, “hidden” to the senses, guarantee that one will be delivered from God’s wrath when it is poured out in the judgment? Yes, affirms Paul. Nothing can stand in its way: not death (5:12–21), not sin (chap. 6), not the law (chap. 7)—nothing! (chap. 8). What God has begun, having justified and reconciled us, he will bring to a triumphant conclusion, and save us from wrath.")]), _vm._v(" "), _c('p', [_vm._v("As 8:18–39 shares a common theme with 5:1–11, so 8:1–17 has much in common with 5:12–21 (see the introduction to chap. 8). And sandwiched between these passages is 6:1–7:25. Here Paul focuses on the situation of the Christian in this life—a situation of some tension and conflict because, while "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.294"
    }
  }), _vm._v("transferred through our justification into the new realm of God’s kingdom, the powers of the old realm to which we no longer belong nevertheless continue to influence us. Temptations to sin, the sufferings that are a part of our sin-sick world, and the last enemy—the death of the body—must still be faced. But, proclaims Paul, the God who has provided for the beginning of spiritual life (justification) and the end (glorification) also provides for the period “between.” In union with Christ, we have been delivered from the tyranny of sin (chap. 6) and the law (chap. 7). At the risk of oversimplifying a complex section and obscuring many other significant connections, we may view the "), _c('i', [_vm._v("main development")]), _vm._v(" of chaps. 5–8 as a “ring composition,” or chiasm:")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "nl"
  }, [_vm._v("A. 5:1–11")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("assurance of future glory")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "nl1"
  }, [_vm._v("B. 5:12–21")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("basis for this assurance in work of Christ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "nl2"
  }, [_vm._v("C. 6:1–23")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("the problem of sin")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "nl2"
  }, [_vm._v("C′. 7:1–25")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("the problem of the law")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "nl1"
  }, [_vm._v("B′. 8:1–17")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("ground of assurance in the work of Christ, mediated by the Spirit")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "nl"
  }, [_vm._v("A′. 8:18–39")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("—")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tdul"
  }, [_vm._v("assurance of future glory")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("In a certain sense, then, 6:1–7:25 is parenthetical to the main point of the section."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.294.13",
      "id": "FN.294.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" But there are many points of contact between this central section and both chaps. 5 and 8, and the topics that are treated in it are hardly incidental."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.294.14",
      "id": "FN.294.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" It is also important to see that the concern for Jewish/Gentile relationships, and the related topic of the Mosaic law, so basic to Paul’s argument in chaps. 1–4, is by no means dropped. In the midst of his depiction of life in Christ, Paul keeps inserting comments about the law (5:13–14, 20; 6:14–15), climaxing in the chapter-long discussion in 7, and spilling over into 8 (vv. 1–4, 7, 15). Paul does not lose sight of the larger theological issue against which, and in relation to which, he hammers out his teaching in Romans. Indeed, Paul contributes in a major way to this motif by showing how many of those privileges and blessings the Jews thought were their own through the law have been “transferred” to the new covenant community that exists “in Christ.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.294.15",
      "id": "FN.294.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', [_vm._v("In chaps. 5–8, then, Paul invites the Christian to join with him in joyful "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.295"
    }
  }), _vm._v("thanksgiving for what the gospel provides—a new life given to God’s service in this life and a certain, glorious hope for the life to come. At the same time Paul is continuing his defense of the gospel. His opponents (probably Jewish, mainly) attacked his message as proclaiming no more than a legal fiction—a “declaration” of a relationship that cannot be proved and which effects no change—and requires no change!—in this life and which offers no security for the day of judgment. Quite the contrary, Paul affirms, the person who has experienced the gospel as the justifying activity of God (cf. 1:17) is assured of finding that gospel to be truly “God’s power for salvation” (cf. 1:16)—power for dedicated Christian service in this life and for deliverance from all the forces of evil and of judgment in the next."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.295.16",
      "id": "FN.295.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "BODY5.1"
    }
  }, [_vm._v("A. THE HOPE OF GLORY (5:1–21)")]), _vm._v(" "), _c('p', {
    staticClass: "chaft",
    attrs: {
      "id": "BODY5.1.1"
    }
  }, [_vm._v("1. From Justification to Salvation (5:1–11)")]), _vm._v(" "), _c('div', {
    staticClass: "written"
  }, [_c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("1")]), _vm._v("Having, therefore, been justified by faith, we have"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.295.17",
      "id": "FN.295.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿17")]), _vm._v(" peace with "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.296"
    }
  }), _vm._v("God through our Lord Jesus Christ, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("2")]), _vm._v("through whom also we have access"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.296.18",
      "id": "FN.296.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿18")]), _vm._v(" into this grace in which we stand; and we boast in the hope of the glory of God. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("3")]), _vm._v("And not only this, but we boast also in our tribulations, knowing that tribulation produces endurance, "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("4")]), _vm._v("and endurance a proven character, and proven character hope.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("5")]), _vm._v("Now this hope will not put us to shame, because the love of God has been poured out into our hearts by the Holy Spirit who has been given to us. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("6")]), _vm._v("For while we were still weak, at just the right time,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.296.19",
      "id": "FN.296.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" Christ died for godless people. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("7")]), _vm._v("For hardly ever will someone die for a righteous person; although for a good person one might dare to die. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("8")]), _vm._v("But God commends his own love for us, in that while we were still sinners Christ died for us.")]), _vm._v(" "), _c('p', {
    staticClass: "wl"
  }, [_c('span', {
    staticClass: "ver"
  }, [_vm._v("9")]), _vm._v("Therefore how much more, having now been justified through his blood, will we be saved through him from wrath. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("10")]), _vm._v("For if, while we were enemies, we were reconciled to God through the death of his Son, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.297"
    }
  }), _vm._v("how much more, being reconciled, will we be saved through his life. "), _c('span', {
    staticClass: "ver"
  }, [_vm._v("11")]), _vm._v("And not only this, but we also boast in God through our Lord Jesus Christ, through whom we have received this reconciliation.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("In this paragraph, Paul invites us to join with him in celebrating the marvelous benefits conferred upon the justified believer: “the Apostle speaks as one who is extremely happy and full of joy” (Luther); “it is now the believer who is speaking—in fact we might almost say, singing” (Leenhardt). Paul highlights two blessings in particular: “peace with God” (or reconciliation) and hope. The former theme occurs at the beginning (vv. 1–2a) and end (v. 11) of the paragraph while the latter is the focus of vv. 2b–10. Some scholars single out reconciliation as the key theme of the paragraph,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.297.20",
      "id": "FN.297.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" while a greater number think that hope is the central concept."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.297.21",
      "id": "FN.297.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" Still others decline to make a choice and give the paragraph a general heading such as “the blessings of justification”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.297.22",
      "id": "FN.297.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" This last alternative is alone broad enough to encompass everything in the paragraph. Paul proclaims that Christians are not only “justified”—“acquitted” in a legal sense—but placed into an entirely new situation, both in the present (“reconciliation”) and in the future (“sharing the glory of God”)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.297.23",
      "id": "FN.297.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")]), _vm._v(" Nevertheless, of these two topics, it is “hope” that comes to dominate the paragraph—in v. 10, for instance, Paul argues from reconciliation to hope. Moreover, it is the topic of “hope” and “glory” that Paul elaborates on in 5:12–21 and 8:14–39, while reconciliation is mentioned without further attention or description.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.298"
    }
  }), _vm._v("The central thrust of the passage is summarized in v. 2b—“we boast in the hope of the glory of God”—and v. 5a—“hope will not put us to shame.” The enumeration of present benefits in vv. 1–2a leads up to this climax in v. 2b. The paradoxical boasting in tribulations of vv. 3–4 is something of an excursus, although it contributes to the central theme by showing that even the sufferings of the Christian lead on to hope (v. 4b). Verses 5–8 set Christian hope on the unshakable foundation of the love of God revealed in the cross. The parallel “how much more” arguments of vv. 9–10 reveal Paul’s concern to show the unbreakable connection between the Christian’s present status (“justified,” “reconciled”) and his fate in the judgment (“saved from wrath”). Verse 11, finally, picks up the “boasting” theme from vv. 2b–3a, returning to the peaceful relationship with God the believer may enjoy in this life."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.298.24",
      "id": "FN.298.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" Paul invites believers to take joyful pride in what God has given them; and, especially, he wants us to have complete assurance that God will deliver us from the final outpouring of his wrath on the day of judgment."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.298.25",
      "id": "FN.298.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("1")]), _vm._v(" The opening phrase of Rom. 5 is transitional. “Therefore, having been justified by faith” not only sums up the central teaching of Rom. 1–4, but, dependent as it is on the first person plural verb following, presents it as a blessing experienced by the readers of the letter. By believing in Jesus Christ, the divine agent in God’s climactic act of deliverance, Paul and the Roman Christians—and Christians of all ages and places—have been declared innocent of all charges justly brought against those who “sin and fall short of God’s glory” (3:23). Paul presents this declaration of justification as a past act, a perspective that is maintained throughout chaps. 5–8."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.298.26",
      "id": "FN.298.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿26")]), _vm._v(" While justification brings to the believer a new and permanent status, justification itself is a once-for-all act by which God acquits the sinner. But what is the exact nature of this new status? What are its implications for our present lives and for the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.299"
    }
  }), _vm._v("future? It is these questions that Paul takes up in this section, and in chaps. 5–8 as a whole.")]), _vm._v(" "), _c('p', [_vm._v("The first implication of our justification is that “we have peace with God.” “Peace” is a word that, like so many in Paul and in the NT, must be understood according to its use in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(", where it translates the wide-ranging Hebrew word "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("shalōm.")]), _vm._v(" As a result, the word “peace”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.299.27",
      "id": "FN.299.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" moves beyond the largely negative signification of the word in secular Greek—“peace” as the cessation or absence of hostilities—to a more positive nuance—the well-being, prosperity, or salvation of the godly person. These are often expressly treated as the gifts of God, as in the well-known benediction, “The "), _c('span', {
    staticClass: "tetr"
  }, [_vm._v("LORD")]), _vm._v(" lift up his countenance on you and give you peace” (Num. 6:26). But especially important for Paul’s usage is the OT prophets’ use of the term peace to characterize the salvation that God would bring to his people in the “last days.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.299.28",
      "id": "FN.299.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" This background defines for us what Paul means by “peace with God”: not an inner sense of well-being, or “feeling at peace” (what we might call the “peace "), _c('i', [_vm._v("of")]), _vm._v(" God” [cf. Phil. 4:7]), but the outward situation of being in a relationship of peace "), _c('i', [_vm._v("with")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.299.29",
      "id": "FN.299.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿29")]), _vm._v(" God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.299.30",
      "id": "FN.299.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")]), _vm._v(" While the word is not used again in this paragraph, the language of “reconciliation” in vv. 10–11 picks up this concept. “Peace,” or “reconciliation” with God, then, “frames” this paragraph. And, despite our emphasis on the “positive” dimensions of “peace” in the OT, we must recognize that Paul conceives this “peace with God” or “reconciliation” as created out of a situation of hostility; it was while we were “enemies” of God that he reconciled us (v. 10). We were weak, ungodly, sinners (vv. 6–8) when God in his love brought us into a new relationship of peace with him.")]), _vm._v(" "), _c('p', [_vm._v("“Peace with God” comes through, and only through, “our Lord Jesus Christ.” As the ultimate locus of God’s atoning, wrath-averting work, Christ is the one through whom the believing sinner receives justification (Rom. 3:25–26). Since peace with God, or reconciliation, is one way of viewing the new relationship into which we have been put by God’s justifying act in Christ, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.300"
    }
  }), _vm._v("it can no more be achieved apart from Christ than can justification itself. That all God has for us is to be found “in” or “through” Jesus Christ our Lord is a persistent motif in Rom. 5–8: peace with God comes “through our Lord Jesus Christ” (5:1); our boasting in God is “through our Lord Jesus Christ” (5:11); grace reigns through righteousness, resulting in eternal life “through Jesus Christ our Lord” (5:21); the gift of God bringing eternal life is “in Christ Jesus our Lord” (6:23); thanks for deliverance are due to God “through Jesus Christ our Lord” (7:25); the love of God, from which nothing can ever separate the believer is “in Christ Jesus our Lord” (8:39). When we consider that these phrases occur in only one other verse in Romans (15:30), and that every chapter in this part of the letter concludes on this note, a very definite focus on this matter is evident here. It is well known that Romans lacks any extended christological discussion per se, but Paul’s repeated insistence in these chapters that all the believer experiences of God’s blessings comes only through Christ develops a very significant christological focus in its own right. Christology, we might say, is not the topic of any part of Rom. 5–8, but it is the basis for everything in these chapters.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("2")]), _vm._v(" As it is “through Jesus Christ our Lord” that we enjoy peace with God, it is through him also that “we have"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.300.31",
      "id": "FN.300.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿31")]), _vm._v(" access into this grace in which we stand.” It is very difficult to know whether we should follow the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NASB"
    }
  }, [_vm._v("NASB")]), _vm._v(" in translating “introduction” or the majority of English translations (e.g., "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.KJV"
    }
  }, [_vm._v("KJV")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NRSV"
    }
  }, [_vm._v("NRSV")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NIV"
    }
  }, [_vm._v("NIV")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.REB"
    }
  }, [_vm._v("REB")]), _vm._v(", and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NAB"
    }
  }, [_vm._v("NAB")]), _vm._v(") and translate “access.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.300.32",
      "id": "FN.300.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(" With the former translation, Paul would be focusing on the believer’s initial entry into the presence of the Lord Christ;"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.300.33",
      "id": "FN.300.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(" with the latter, the attention is more on the believer’s continuing ability to enjoy the presence of Christ. As my translation suggests, however, I think the context—in which Paul focuses on the blessings enjoyed by the believer as a result of being justified—favors the translation “access.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.300.34",
      "id": "FN.300.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" Rather than making “God” the object of “access,” as we "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.301"
    }
  }), _vm._v("might have expected (see Eph. 2:18), Paul chooses “grace.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.301.35",
      "id": "FN.301.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" But it is not just to “grace” in general that we have access; but to “this grace in which we stand.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.301.36",
      "id": "FN.301.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(" Paul has stressed at key points in his argument that all the believer has comes by grace (3:24; 4:16). Grace describes the free, unconstrained manner in which God acts toward his creatures (see also Rom. 11:5–6). Later in Rom. 5, Paul will use “grace” to denote the act of God in Christ (vv. 15, 17). Here, however, grace is used with a slightly different nuance, denoting not the manner in which God acts, or the gift that God gives, but the “state” or “realm” into which God’s redeeming work transfers the believer. It is the realm in which “grace reigns” (5:21), a realm that is set in contrast to the realm or domain of the law (6:14, 15: the believer is not “under the law” but “under grace”; cf. also Gal. 5:4)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.301.37",
      "id": "FN.301.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" Without denying the presence of God’s grace throughout human history, Paul, along with the rest of the NT (cf. John 1:17), so focuses on God’s work in Christ as that act in which God’s grace was decisively and finally realized that he can picture the new status of the believer as one in which grace is characteristic and dominant. While this state of grace includes our justification as a key element,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.301.38",
      "id": "FN.301.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" the notion goes beyond justification to all that is conveyed to us by God in Christ.")]), _vm._v(" "), _c('p', [_vm._v("Included in that panoply of blessings is hope. As Paul in vv. 1–2a looks at the present situation of the Christian in light of the past, he now begins to contemplate that situation in light of the future."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.301.39",
      "id": "FN.301.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" This is the note that will dominate this paragraph, and “we boast in the hope of the glory of God”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.301.40",
      "id": "FN.301.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" is the key assertion in the passage. The word “boast” suggests here confidence "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.302"
    }
  }), _vm._v("and joy; perhaps we could render “we are joyfully confident of.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.302.41",
      "id": "FN.302.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(" “Boasting” in human achievement is excluded by the gospel (3:27; cf. 4:2), but “boasting” because of the gracious provision of God in Christ is entirely appropriate. As in 3:23, “the glory of God” is that state of “God-like-ness” which has been lost because of sin, and which will be restored in the last day to every Christian (cf. 8:17, 18, 21, 30). A joyful confidence in this prospect, overcoming our (proper) frustration at our present failure to be all that God would want us to be, should be the mark of every believer.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("3a")]), _vm._v(" As Paul in the parallel 8:18–30 contrasts the “glory that will be revealed in us” with “present sufferings” (v. 18), so he here turns quickly from our boasting in the hope of God’s glory to our boasting in “tribulations.” As Gifford puts it, “No sooner has the Apostle pointed to ‘the glory of God,’ as a light shining afar to cheer the believer on his course, than he thinks of the contrast between that bright distance and the darkness that lies around him here.” It is probably to head off criticism of his teaching that Paul introduces the “problem” of suffering. For (particularly) Jewish objectors would be likely to question Paul sharply about his affirmation that the Christian is enjoying “peace with God” when that same Christian is facing illness, persecution, and difficulties of all kinds. Indeed, Christians themselves, then as today, were surely wondering about the reality of these blessings in the face of suffering. Characteristically, Paul takes an offensive posture. Not only do sufferings not overthrow the reality of these blessings, but they are themselves occasions for joyful boasting! The believer should boast “not only” in the hope of the glory of God “but also” in afflictions. This means not merely that we are to exult “in the midst of” afflictions but that we are to exult “in”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.302.42",
      "id": "FN.302.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" the afflictions themselves: that is, to view them as a basis for further confidence in our redeemed status.")]), _vm._v(" "), _c('p', [_vm._v("What are these “afflictions”?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.302.43",
      "id": "FN.302.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" Some would confine them to those sufferings caused directly by the believer’s profession of Christ. But Paul’s "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.303"
    }
  }), _vm._v("use of the word “affliction(s)” makes any such restriction questionable. Indeed, in a certain sense, all sufferings are “on behalf of Christ.” This is so because all the evil that the Christian experiences reflects the conflict between “this age,” dominated by Satan, and “the age to come,” to which the Christian has been transferred by faith. All suffering betrays the presence of the enemy and involves attacks on our relationship to Christ. If met with doubt in God’s goodness and promise, or bitterness toward others, or despair and even resignation, these sufferings can bring spiritual defeat to the believer. But if met with the attitude of “confidence and rejoicing” that Paul encourages here, these sufferings will produce those valuable spiritual qualities that Paul lists in vv. 3b–4.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("3b–4")]), _vm._v(" The reason why the believer can “rejoice in afflictions” is that he or she “knows”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.303.44",
      "id": "FN.303.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" that affliction “produces"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.303.45",
      "id": "FN.303.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿45")]), _vm._v(" endurance,” and endurance, in turn, “a tested character,” and a tested character, in turn, hope. Sequences of this kind, in which suffering inaugurates a chain of linked virtues, are introduced as a stimulus to face difficulties with joy in two other NT texts (1 Pet. 1:6b–7; Jas. 1:2–4) and must have been popular in the early church—probably reflecting earlier Jewish exhortation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.303.46",
      "id": "FN.303.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" As in Jas. 1:3, the first virtue in the list is “endurance,” a word that denotes the spiritual fortitude that bears up under, and is, indeed, made even stronger by, suffering."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.303.47",
      "id": "FN.303.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" It suggests that “stick-to-itiveness” which is required if the word of God is to produce fruit in us (Luke 8:15) and that long-distance, marathoner’s endurance which will enable us to run the race set before us right to the finish line (Heb. 12:1). “Endurance,” in turn, will, if our attitude is right, produce a “tested character.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.303.48",
      "id": "FN.303.48r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" As a result of this tested character, finally, the Christian who responds to sufferings with the proper attitude will find, at the end of the line, that hope has been strengthened. Sufferings, rather than threatening or weakening our hope, as we might expect to be the case, will, instead, increase our certainty in that hope. Hope, like a muscle, will not be strong if it goes unused. It is in "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.304"
    }
  }), _vm._v("suffering that we must exercise with deliberation and fortitude our hope, and the constant reaffirmation of hope in the midst of apparently “hopeless” circumstances will bring ever-deeper conviction of the reality and certainty of that for which we hope (see Rom. 4:18–19).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("5")]), _vm._v(" This verse makes clear that “hope” is the focal point of 5:1–11. It functions as a “hinge” in the paragraph (Godet), attached on the one side to v. 2b, which v. 5a reiterates and expands, and on the other side to vv. 6–10, which v. 5b introduces. We can rejoice in hope, knowing it will not disappoint us, because of the “amazing grace” of God’s love (vv. 5b–8) and because of the decisive and final significance of what God has done for us in Christ (vv. 9–10).")]), _vm._v(" "), _c('p', [_vm._v("The first part of v. 5—“Now this hope will not put us to shame”—is reminiscent of OT passages that affirm that those who hope in God will not “be put to shame.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.304.49",
      "id": "FN.304.49r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" Christians need not fear that the judgment will “put them to shame,” in the sense that the foundation on which they have built their lives and hope for eternal blessing should prove inadequate. The last clause of the verse is causal: Christians are confident that they will not be put to shame “because"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.304.50",
      "id": "FN.304.50r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿50")]), _vm._v(" the love of God has been poured out into our hearts by the Holy Spirit who has been given to us.” Granted this purpose, and Paul’s choice of the verb “pour out,” it is certain that we should paraphrase “the love of God for us” rather than “our love for God.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.304.51",
      "id": "FN.304.51r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")]), _vm._v(" The confidence we have for the day of judgment is not based only on our intellectual recognition of the fact of God’s love, or even only on the demonstration of God’s love on the cross (although that is important; cf. vv. 6–8), but also on the inner, subjective certainty that God does love us. This is the point Paul is making by affirming that God’s love has been “poured out in our hearts through the Holy Spirit who was given to us.” The verb “pour out”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.304.52",
      "id": "FN.304.52r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")]), _vm._v(" connotes an abundant, “extravagant,” effusion: “he does not say ‘given’ but ‘shed abroad in our hearts,’ so showing the profusion of it” (Chrysostom). Paul uses this same "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.305"
    }
  }), _vm._v("verb to depict the “pouring out” of God’s Spirit (Tit. 3:6; cf. Acts 2:17, quoting Joel 2:28–32). This raises the possibility that the “real” subject of “pour out” is the Holy Spirit, who witnesses to our hearts of the love of God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.305.53",
      "id": "FN.305.53r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")]), _vm._v(" But we must respect Paul’s decision to make “the love of God” the subject of the verb."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.305.54",
      "id": "FN.305.54r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")]), _vm._v(" Paul is asserting two things at once: that God’s love has been poured into our hearts in the past, and that this love is now within us."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.305.55",
      "id": "FN.305.55r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")]), _vm._v(" And this love is conveyed to our sensations by the Holy Spirit, who resides in every believer."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.305.56",
      "id": "FN.305.56r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('p', [_vm._v("For the first time in Romans, Paul speaks of God’s love, a topic that is more prominent in Paul than we sometimes realize (cf. Morris). Paul stresses that God’s love for us is active—it is a love that gives to us and takes possession of us (cf., e.g., 2 Cor. 5:14: “the love of Christ controls us”), and which can stand for all that God has done and will do for us (cf. 8:35: “Who shall separate us from the love of Christ?”). Paul’s language reflects prophetic descriptions of the eschatological gift of God’s Spirit as part of the inauguration of the New Covenant."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.305.57",
      "id": "FN.305.57r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")]), _vm._v(" That covenant promises a new and permanent relationship between God and his people, a relationship in which our “sins are remembered no more” (Jer. 31:34) and in which we are given a hope that involves “being changed into Christ’s likeness from one degree of glory to another” (2 Cor. 3:12–18)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.305.58",
      "id": "FN.305.58r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")]), _vm._v(" What in the Old Covenant was (in some respects, at least) external has been internalized in the New Covenant. And it is this internal, subjective—yes, even emotional—sensation within the believer that God does indeed love us—love expressed and made vital in real, concrete actions on our behalf—that gives to us the assurance that “hope will not disappoint us.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.305.59",
      "id": "FN.305.59r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("6")]), _vm._v(" Verses 6–8 form a single argument that demonstrates the abundant and absolute nature of God’s love for us. We may summarize Paul’s argument (making explicit some points that are implicit) as follows:")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('p', {
    staticClass: "nl"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.306"
    }
  }), _vm._v("a. Human love, at its best, will motivate a person to give his or her life for a truly “good” person (v. 7);")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("b. Christ, sent by God, died, not for “righteous” people, or even for “good” people, but for rebellious and undeserving people (v. 6);")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("c. Therefore: God’s love is far greater in its magnitude and dependability than even the greatest human love (v. 8).")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("This argument functions not only to provide evidence for the love of God (and especially its profusion [“poured out”]) by tracing that love we experience in our hearts to its source but also, in doing so, to substantiate the utter dependability of our hope (v. 5a)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.306.60",
      "id": "FN.306.60r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")]), _vm._v(" Paul accentuates the unity of the argument in vv. 6–8 by ending each sentence (in the Greek text) with the verb “die.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.306.61",
      "id": "FN.306.61r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" "), _c('p', [_vm._v("The first sentence in Paul’s argument (v. 6) is syntactically complex, but clear enough in its meaning: “For while we were still weak, at just the right time, Christ died for godless people.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.306.62",
      "id": "FN.306.62r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")]), _vm._v(" Paul makes clear the point he especially wants to convey here by characterizing the human beings Christ died for as both “godless” and “weak.” “Godless” is a strong pejorative term in Paul (cf. Rom. 4:5); “weak” is not always as negative, but here designates that “total incapacity for good” which is characteristic of the unredeemed."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.306.63",
      "id": "FN.306.63r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")]), _vm._v(" Paul thereby stresses that God’s love came to us when we were utterly helpless."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.306.64",
      "id": "FN.306.64r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.307"
    }
  }), _vm._v("Paul’s assumptions about the intimate relationship between God and Christ, as well as his concern to highlight the practical, concrete nature of God’s love, surfaces in his argument that "), _c('i', [_vm._v("Christ’s")]), _vm._v(" dying “for"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.307.65",
      "id": "FN.307.65r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿65")]), _vm._v(" us” demonstrates the love "), _c('i', [_vm._v("“of God”")]), _vm._v(" (v. 5; and note the reference to the Holy Spirit in v. 5b). Paul never thinks of God’s love for us apart from the cross, and he never thinks of Christ’s dying for us apart from the Father’s giving of the Son (cf. Rom. 3:25). The most puzzling element in this verse is the prepositional phrase “at just the right time.” The phrase probably modifies the main clause of the verse, “Christ died for godless people.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.307.66",
      "id": "FN.307.66r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")]), _vm._v(" But what does Paul mean by saying that Christ died “at the appropriate time”?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.307.67",
      "id": "FN.307.67r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")]), _vm._v(" He may mean that it was the “right” time in world history for the sending of Christ and the proclamation of the gospel."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.307.68",
      "id": "FN.307.68r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")]), _vm._v(" Or he may be thinking of the time as “right” because it was the time when, had not Christ died, God’s wrath would have been poured out."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.307.69",
      "id": "FN.307.69r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")]), _vm._v(" Related to both these suggestions, but with better foundation in Paul’s theology, is the interpretation that takes “right time” to mean the culminating, eschatological “time” of God’s intervention in Christ (see Rom. 3:26; 8:18; 13:11)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.307.70",
      "id": "FN.307.70r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")]), _vm._v(" This last suggestion, which is the best of the three, is yet open to the objection that Paul usually adds a qualifier to “time” when it has this meaning. Considering the context, it is best to give the phrase a less theological and more prosaic meaning, and take it as further emphasizing “still”: “Christ died for the ungodly just "), _c('i', [_vm._v("at that very time")]), _vm._v(" when we were weak.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.307.71",
      "id": "FN.307.71r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("7")]), _vm._v(" The main point of this verse is clear enough. Paul accentuates the love of God manifested in the cross of Christ by reminding us that the pinnacle of human love is the giving of one’s life for a person one is close to—a spouse, child, or combat buddy—whereas God sent his Son to die for people who hated "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.308"
    }
  }), _vm._v("him (v. 8)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.308.72",
      "id": "FN.308.72r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")]), _vm._v(" But Paul’s way of stating this point creates some confusion. For it is not clear what the relationship between the two clauses is—“hardly ever"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.308.73",
      "id": "FN.308.73r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿73")]), _vm._v(" will someone die"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.308.74",
      "id": "FN.308.74r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿74")]), _vm._v(" for a righteous person; although for a good person one might dare to die.” Interpretations fall into two categories. On the one hand are those that do not make any important distinction between “righteous person” in the first sentence and “good person” in the second. If this is so, the second sentence could be the replacement for the first, Tertius, Paul’s scribe, accidentally leaving in the first, “uncorrected,” sentence."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.308.75",
      "id": "FN.308.75r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")]), _vm._v(" Or it could clarify the first by “softening” the assertion that a person would “scarcely” die for anyone else."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.308.76",
      "id": "FN.308.76r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")]), _vm._v(" In the second category are those interpretations that give to the second sentence a concessive force: “one would scarcely die for a righteous person, "), _c('i', [_vm._v("although")]), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.308.77",
      "id": "FN.308.77r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿77")]), _vm._v(" for a good person, one might, indeed, be willing to die.” On this view, a “good person” would be one who has a stronger claim on one’s emotions than the “righteous person” of the first clause. While the “righteous person” would be one who is just and upright in his dealings and would therefore have some claim on our respect, the “good person” would be one for whom we have a strong personal attachment and for whom, therefore, we would be more willing to die."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.308.78",
      "id": "FN.308.78r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")]), _vm._v(" It is true that a distinction of this sort between “righteous” and “good” does not have much NT support."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.308.79",
      "id": "FN.308.79r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")]), _vm._v(" But it does find some support in extrabiblical materials."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.308.80",
      "id": "FN.308.80r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.309"
    }
  }), _c('span', {
    staticClass: "hemb"
  }, [_vm._v("8")]), _vm._v(" In contrast to"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.309.81",
      "id": "FN.309.81r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿81")]), _vm._v(" the very best of human love is God’s love; for he “commends"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.309.82",
      "id": "FN.309.82r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿82")]), _vm._v(" his own"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.309.83",
      "id": "FN.309.83r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿83")]), _vm._v(" love for us,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.309.84",
      "id": "FN.309.84r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")]), _vm._v(" in that"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.309.85",
      "id": "FN.309.85r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿85")]), _vm._v(" while we were still sinners Christ died for us.” Again we see the assumption that "), _c('i', [_vm._v("God’s")]), _vm._v(" love is shown in "), _c('i', [_vm._v("Christ’s")]), _vm._v(" death (cf. v. 6). We notice also that Paul finds a basic unity, even identity, between the love of God as it is shown in the objective, factual event of Christ’s death on the cross and as it is experienced “in the heart” by the believer (v. 5b). An emotional feeling of God’s love, in itself, is little comfort to the person who is lost, condemned, doomed for hell. But a cold, sober, historical interpretation that indeed God “loved the world” on the cross is of little benefit to a person until that love is experienced, is received, by faith in Christ. It is when these are properly experienced as two aspects of one great love, ultimately indivisible, that our assurance that “hope will not put us to shame” (v. 5a) will be strong and unshakable.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("9")]), _vm._v(" In vv. 9–10, Paul gathers together the main pieces of vv. 1–8 into a synthesis that reiterates and expands the central point of the paragraph as a whole: the certainty of Christian hope (vv. 2b, 5a). The two verses are parallel statements of the same point, as the following layout shows:")]), _vm._v(" "), _c('div', {
    staticClass: "senseline"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "borderbot"
  }, [_c('p', {
    staticClass: "tchleft"
  }, [_vm._v("v. 9")])]), _vm._v(" "), _c('td', {
    staticClass: "borderbot"
  }, [_c('p', {
    staticClass: "tchleft"
  }, [_vm._v("v. 10")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("if, while we were enemies,")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("having now been justified")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("we were reconciled to God")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("through his blood")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("through the death of his Son")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("how much more")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("how much more")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("being reconciled")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("will we be saved")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("will we be saved")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("from wrath")])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("through him")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "td"
  }, [_vm._v("through his life")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("The argument in each of the verses takes the form of a popular logical sequence, called by the rabbis "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("qal wayyōmer")]), _vm._v(" (“light and heavy”) and in the western tradition "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("a minori ad maius")]), _vm._v(" (“from the minor to the major”)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.309.86",
      "id": "FN.309.86r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")]), _vm._v(" In "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.310"
    }
  }), _vm._v("this case, however, the “how much more” in Paul’s transition suggests that the argument proceeds from the “major” to the “minor”:"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.310.87",
      "id": "FN.310.87r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")]), _vm._v(" if God has already done the most difficult thing—reconcile and justify unworthy sinners—how much more can he be depended on to accomplish the “easier” thing—save from eschatological wrath those who have been brought into such relationship with him. In this double statement, Paul incorporates in the first member many of the elements of present Christian experience that he has touched on in vv. 1–8: “being justified by faith” (v. 1a; alluded to in v. 9a), “having peace with God” (v. 1b; picked up in the language of reconciliation in v. 10), having the love of God, revealed on the cross, in our hearts (vv. 5b–8; suggested by the stress on the death of "), _c('i', [_vm._v("God’s")]), _vm._v(" Son in v. 10), having experienced all this when we were “ungodly,” “weak,” “sinners” (vv. 6–8; cf. v. 10a: “enemies”). Similarly, the second part of the argument restates and elaborates the “hope” of vv. 2b and 5a.")]), _vm._v(" "), _c('p', [_vm._v("As in v. 1, “being justified”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.310.88",
      "id": "FN.310.88r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")]), _vm._v(" alludes to the past declaration of acquittal pronounced over the sinner who believes in Christ. But the “now” adds the nuance of the continuing “just” status of those so acquitted. The means by which this justifying act takes place is Christ’s blood."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.310.89",
      "id": "FN.310.89r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")]), _vm._v(" As in 3:25, “blood” signifies Christ’s death as a sacrifice for sins. These are the only two places in Romans in which “blood” has this sacrificial sense, and the other similarities between vv. 9–10 and 3:21–26 (justification, deliverance from wrath [alluded to with "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("hilastērion")]), _vm._v("]) suggest that Paul may here be drawing from that compact summary of the work of Christ."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.310.90",
      "id": "FN.310.90r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")]), _vm._v(" The justified status conveyed to the believer on the basis of Christ’s sacrificial death issues in salvation from wrath. The temporal element in the verse makes clear that wrath refers here to eschatological judgment (cf. 2:5). “We will be saved” is, then, a genuine temporal future. As he typically does, Paul uses salvation language to depict the final deliverance of the believer from sin, death, and judgment."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.310.91",
      "id": "FN.310.91r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")]), _vm._v(" Salvation, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.311"
    }
  }), _vm._v("accomplished in Christ and the believer’s appropriation of Christ, is finally realized only in the last day. This double temporal conception is typical of NT teaching, which insists on the absolute and final nature of the believer’s acceptance of salvation while also maintaining that salvation is not complete until the body is redeemed and glorified (cf. Rom. 8:23; Phil. 3:21). It is precisely the tension set up by this “already-not yet” perspective that gives rise to the need to proclaim the unbreakable connection between the believer’s justification and his or her salvation from the wrath of God still to be poured out in the last day. Paul suggests the unbreakable connection between the two by insisting that, as initial salvation is “through his blood,” so final salvation is also “through him.” In light of the parallel phrase in v. 11, “in his life,” Paul probably means by this the mediation of the risen Christ, who, through his resurrection, has been “appointed as Son-of-God-in-power” (cf. 1:4; 8:35)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.311.92",
      "id": "FN.311.92r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("10")]), _vm._v(" The parallelism between this verse and v. 9 renders the differences between them all the more significant. Perhaps the most interesting is the substitution of “reconciled” for “justified.” Justification language is legal, law-court language, picturing the believer being declared innocent by the judge. Reconciliation language, on the other hand, comes from the world of personal relationships. “To reconcile” means to bring together, or make peace between, two estranged or hostile parties (cf. 1 Cor. 7:11)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.311.93",
      "id": "FN.311.93r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")]), _vm._v(" The language of reconciliation is seldom used in other religions because the relationship between human beings and the deity is not conceived there in the personal categories for which the language is appropriate."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.311.94",
      "id": "FN.311.94r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")]), _vm._v(" Reconciliation in Paul has two aspects, or “moments”: the accomplishment of reconciliation through Christ on the cross (cf. 2 Cor. 5:19: “in Christ God was reconciling the world to himself”)"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.311.95",
      "id": "FN.311.95r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")]), _vm._v(" and the acceptance of that completed work by the believer (cf. 2 Cor. 5:20b: “We beseech you on behalf of Christ, be reconciled to God”)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.311.96",
      "id": "FN.311.96r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.312"
    }
  }), _vm._v("Naturally, while the focus can be on one of these moments or the other, the reconciling activity of God is ultimately one act; and in the present verse the complete process is in view. Paul makes explicit the hostile relationship implicit in the language of reconciliation: it was “while we were enemies” that we were reconciled to God. Paul may mean by this simply that we, rebellious sinners, are hostile toward God—violating his laws, putting other gods in his place."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.312.97",
      "id": "FN.312.97r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")]), _vm._v(" But, as Paul has repeatedly affirmed in this letter (cf. 1:18; 3:25), God is also “hostile” toward us—our sins have justly incurred his wrath, which stands as a sentence over us (1:19–32), to be climactically carried out on the day of judgment (2:5). Probably, then, the “enmity” to which Paul refers here includes God’s hostility toward human beings as well as human beings’ hostility toward God."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.312.98",
      "id": "FN.312.98r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")]), _vm._v(" Outside of Christ, people are in a situation of “enmity” with God; and in reconciliation, it is that status, or relationship, that changes: we go from being God’s “enemies” to being his “children” (cf. Rom. 8:14–17).")]), _vm._v(" "), _c('p', [_vm._v("As in v. 9 justification is accomplished “through” Christ’s blood, so here reconciliation takes place “through"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.312.99",
      "id": "FN.312.99r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿99")]), _vm._v(" the death of [God’s] Son.” Similarly, “we will be saved,” though not further defined, must have the same referent as the same verb in v. 9: salvation from the wrath of God on the day of judgment. The meaning of the phrase “through"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.312.100",
      "id": "FN.312.100r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿100")]), _vm._v(" his life” is not so clear. In light of Paul’s frequent, and theologically significant, use of “in Christ” language in Rom. 5–8, he could intend to depict our salvation as occurring “in the sphere of” Christ, or his life."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.312.101",
      "id": "FN.312.101r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")]), _vm._v(" On the other hand, it is unusual for Paul to use “in Christ” language with another noun intervening between the preposition and “Christ”; and the phrase seems to be parallel to “through him” in v. 9, where an instrumental meaning is certain. Probably, then, the phrase indicates that the new life won by Christ and in which believers share is the means by which they will be saved in the judgment."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.312.102",
      "id": "FN.312.102r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "hemb"
  }, [_vm._v("11")]), _vm._v(" This verse wraps up the section by rehearsing many of its key "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.313"
    }
  }), _vm._v("elements: “boasting/rejoicing” (cf. vv. 2–3); the present experience of reconciliation with God (vv. 1b, 10); and, most of all, the fact that this boasting, and this reconciliation, are “through our Lord Jesus Christ” (vv. 1, 2, 6–8, 9, 10)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.103",
      "id": "FN.313.103r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")]), _vm._v(" But the exact relationship of this verse to the rest of the paragraph is dependent on decisions we must make about two syntactical issues. First is the question of the point of comparison in the transitional phrase “and not only this.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.104",
      "id": "FN.313.104r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")]), _vm._v(" If Paul intends these words as a transition from the immediately preceding verse, then the point of comparison could be “we will be saved”—“and not only will we be saved, but …”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.105",
      "id": "FN.313.105r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")]), _vm._v("—or “being reconciled”—“and not only [are we those] who are reconciled, but [we are those] rejoicing.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.106",
      "id": "FN.313.106r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")]), _vm._v(" On the other hand, Paul may want us to go further back into the text for the implied connection: either to the last use of “rejoice” in v. 3—“and not only do we rejoice in afflictions, but we rejoice also in …”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.107",
      "id": "FN.313.107r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")]), _vm._v("—or, more generally, to the teaching of vv. 3–10 as a whole—“and not only is all this true, but.…”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.108",
      "id": "FN.313.108r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")]), _vm._v(" Since Paul elsewhere uses this transitional phrase to pick up an immediately preceding statement,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.109",
      "id": "FN.313.109r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")]), _vm._v(" it is more likely that Paul wants us to supply something from v. 10; and “salvation” is more likely than “reconciliation,” since the latter occurs later in the verse.")]), _vm._v(" "), _c('p', [_vm._v("The second issue has to do with the mood of the verb we have translated “boast.” It is a participle in Greek,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.110",
      "id": "FN.313.110r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")]), _vm._v(" and it could well then be a subordinate verb, with a main verb to be discovered. This main verb could be “we will be saved” from v. 10."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.111",
      "id": "FN.313.111r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿111")]), _vm._v(" But taking the participle as the main verb of the sentence is grammatically unobjectionable"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.112",
      "id": "FN.313.112r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿112")]), _vm._v(" and makes for a smoother reading. We take it, then, that Paul in v. 11 is turning back from the future prospect of the believer, with which he has been occupied in vv. 5–10, to the “boasting” or “rejoicing”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0013a#FN.313.113",
      "id": "FN.313.113r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")]), _vm._v(" that marks the reaction of the believer in this life to all that God has done for him or her (cf. vv. 1–4)—rejoicing that everything God gives us is “through our Lord Jesus Christ.” But perhaps we should say, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.314"
    }
  }), _vm._v("“should mark” the reaction of the believer—for although Paul states our boasting as a fact, he undoubtedly wants to encourage any who are faltering or downhearted to contemplate again what he or she has in Christ—a new relationship with God (“justification,” “peace with God,” “reconciliation”) that overcomes all present adversity (“rejoicing in afflictions”) and that provides absolute security for the life to come (“rejoicing in the glory of God,” “hope does not disappoint us,” “saved from wrath”). And such contemplation can lead only to rejoicing. So Chrysostom: “And so the fact of his saving us, and saving us too when we were in such plight, and doing it by means of his only-begotten, and not merely by his only-begotten, but by his blood, weaves for us endless crowns to glory in.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f03340b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eernicnt66ro0011b.vue
// module id = 90
// module chunks = 0